import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ViewEncapsulation,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { MatSelect } from "@angular/material/select";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { opdEnvironment } from "../../properties/opd-field-properties";
import { AppointmentService } from "../../services/Sappointment.service";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { ReplaySubject, Subject, Subscription, takeUntil } from "rxjs";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { Router, ActivatedRoute } from "@angular/router";
import { AppointmentDetailsComponent } from "./appointment-details/appointment-details.component";
import { ItemModel } from "@syncfusion/ej2-angular-splitbuttons";
import { TextBoxComponent } from "@syncfusion/ej2-angular-inputs";
import {
  ScheduleComponent,
  GroupModel,
  View,
  EventSettingsModel,
  Timezone,
  ResourcesModel,
  PopupOpenEventArgs,
  TimeScaleModel,
  DayService,
  WeekService,
  WorkWeekService,
  MonthService,
  YearService,
  AgendaService,
  TimelineViewsService,
  TimelineMonthService,
  TimelineYearService,
  PrintService,
  ExcelExportService,
  ICalendarExportService,
  DragAndDropService,
  NavigatingEventArgs,
} from "@syncfusion/ej2-angular-schedule";
import { extend, Internationalization } from "@syncfusion/ej2-base";
import { SwitchComponent } from "@syncfusion/ej2-angular-buttons";
import {
  MultiSelectComponent,
  ChangeEventArgs,
  MultiSelectChangeEventArgs,
  DropDownListComponent,
} from "@syncfusion/ej2-angular-dropdowns";
import { Predicate, Query } from "@syncfusion/ej2-data";
import {
  ContextMenuComponent,
  MenuItemModel,
} from "@syncfusion/ej2-angular-navigations";
import { ChangeEventArgs as TimeEventArgs } from "@syncfusion/ej2-calendars";
import { MatTableDataSource } from "@angular/material/table";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { MasterUrlService } from "../../services/SmasterUrl.service";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { removeSpaces } from "../../helper/helper.service";
import {
  OPD_REPORT_NAME,
  OPD_REPORT_TYPE,
} from "../../properties/opd-report-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import { ConfirmRemarksComponent } from "./confirm-remarks/confirm-remarks.component";
import { AppointmentQuickSearchComponent } from "./appointment-quick-search/appointment-quick-search.component";
import {
  PATIENT_SEARCH,
} from "../../properties/patient-search-properties";
import { SearchModel } from "../../models/MsearchModel";
import moment from "moment";
import { dataObj } from "../../models/MpatientRegistration";
import { baseObj, baseObject } from "../../interface/IerRegistration";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MASTERSSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/master-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { PatientDTOObject } from "projects/lib/medcare-core-lib/src/lib/core/patient-search/patient-search.component";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { ReportService } from "projects/lib/medcare-core-lib/src/lib/services/report.service";
import { MasterMenus } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { MasterKeys } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";
import { RecurringAppointmentsComponent } from "./recurring-appointments/recurring-appointments.component";

export interface DialogData {
  name: string;
}
@Component({
  selector: "app-patient-appointment",
  templateUrl: "./patient-appointment.component.html",
  styleUrls: ["./patient-appointment.component.scss"],
  providers: [
    DatePipe,
    AuthService,
    DayService,
    WeekService,
    WorkWeekService,
    MonthService,
    YearService,
    AgendaService,
    TimelineViewsService,
    TimelineMonthService,
    TimelineYearService,
    PrintService,
    ExcelExportService,
    ICalendarExportService,
    DragAndDropService,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PatientAppointmentComponent implements OnInit, OnDestroy {
  public deptCtrl: FormControl = new FormControl();
  public deptFilterCtrl: FormControl = new FormControl();
  public teleCtrl: FormControl = new FormControl();
  public teleFilterCtrl: FormControl = new FormControl();
  public appointmentTypeCtrl: FormControl = new FormControl();
  public appointmentTypeDFltrCtrl: FormControl = new FormControl();
  public doctorCtrl: FormControl = new FormControl();
  public doctorFltrCtrl: FormControl = new FormControl();
  public filteredDepts: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredTelecom: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredDocs: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredappointmentType: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();
  public environment: any = opdEnvironment;
  public currentDate: string;
  public name: string;
  public appointmentType: any = {};
  public appointmentTypeList: any = [];
  public Teleconsultations: any = [];
  public departmentList: any = [];
  public doctorList: any = [];
  multiLangDepartmentList: any[] = [];
  multiLangDoctorList: any[] = [];
  public departmentName: string;
  public department: any = {};
  public doctor: any = {};
  public teleconsultaion: any = {};
  public pageLoad = true;
  public deptFlag = false;
  mulipleDoctor: boolean = false;
  public activeDoctor: any = {
    code: "",
    id: "",
    name: "",
    department: "",
    email: "",
  };
  public values: any = {};
  public searchResult: any = {
    appointmentDate: {
      start: new Date(),
      end: new Date(),
    },
    doctor: "",
    mrnno: "",
  };
  public events = [];
  isHidden = false;
  minutesblock = 30;
  blockTime: any;
  unitId: any;
  unitCode: any;
  orgId: any;
  render: any;
  startDate: any;
  apptType: any;
  customArray: any[] = [];
  multiDocCheckbox: boolean = true;
  allSlots: any[] = [];
  multipleDoctors: any[] = [];
  parentMessage: any;
  details: any = {};
  multipleDoctorSlected: any[] = [];
  doctorsCount: string = "";
  private subscriptionList = new Subscription();
  searchJson = PATIENT_SEARCH;
  search: SearchModel = new SearchModel();
  patientSearchList: any;
  refreshTime: string = "";
  patient: PatientDTOObject = new PatientDTOObject();
  hidePatientSearch: boolean = false;
 

  //sync fusion calendar
  @ViewChild("scheduleObj", { static: true }) scheduleObj: ScheduleComponent;
  @ViewChild("singleSelect", { static: true }) singleSelect: MatSelect;
  @ViewChild("appointmentTypeSelect", { static: true })
  appointmentTypeSelect: MatSelect;
  @ViewChild("deptTypeSelect", { static: true }) deptTypeSelect: MatSelect;
  @ViewChild("doctorSelect", { static: true }) doctorSelect: MatSelect;

  @ViewChild("workWeekDaysObj", { static: true })
  workWeek: MultiSelectComponent;
  @ViewChild("resouresObj", { static: true }) resources: MultiSelectComponent;
  @ViewChild("eventTypeObj", { static: true })
  eventTypeObj: DropDownListComponent;
  @ViewChild("titleObj", { static: true }) titleObj: TextBoxComponent;
  @ViewChild("notesObj", { static: true }) notesObj: TextBoxComponent;
  @ViewChild("viewSwitch", { static: true }) viewSwitch: SwitchComponent;
  @ViewChild("groupSwitch", { static: true }) groupSwitch: SwitchComponent;
  @ViewChild("gridlinesSwitch", { static: true })
  gridlinesSwitch: SwitchComponent;
  @ViewChild("rowHeightSwitch", { static: true })
  rowHeightSwitch: SwitchComponent;
  @ViewChild("tooltipSwitch", { static: true }) tooltipSwitch: SwitchComponent;
  @ViewChild("dragSwitch", { static: true }) dragSwitch: SwitchComponent;
  @ViewChild("menuObj", { static: true }) public menuObj: ContextMenuComponent;
  public showFileList = false;
  public multiple = false;
  public intl: Internationalization = new Internationalization();
  public currentView: View = "Week"; //string not able to assigned
  public liveTimeUpdate: string = new Date().toLocaleTimeString(
    OPD_CONST.aptTimeRef.enus,
    {
      timeZone: OPD_CONST.aptTimeRef.utc,
    }
  );
  public group: GroupModel = { resources: [] };
  public resourceDataSource: Record<string, any>[] = OPD_CONST.aptResource;
  dataSource = new MatTableDataSource<any>();
  public resourceQuery: Query = null;
  public allowMultiple = false;
  public isTimelineView = false;
  public exportItems: ItemModel[] = OPD_CONST.aptItemModel;
  public checkboxMode = OPD_CONST.aptref.checkbox;
  public firstDayOfWeek = 0;
  public workDays: number[] = OPD_CONST.aptWorkDays;
  public calendarsValue: number[] = [1];
  public selectedResource: number = 1;
  public fields: Record<string, any> = OPD_CONST.aptRecords;
  public calendarFields: Record<string, any> = OPD_CONST.aptcalenderFields;
  public dayStartHourValue: Date = new Date(new Date().setHours(0, 0, 0));
  public dayEndHourValue: Date = new Date(new Date().setHours(23, 59, 59));
  public workStartHourValue: Date = new Date(new Date().setHours(9, 0, 0));
  public workEndHourValue: Date = new Date(new Date().setHours(18, 0, 0));
  public weekDays: Record<string, any>[] = OPD_CONST.aptweekDays;
  public timezoneData: Record<string, any>[] = OPD_CONST.aptTimeZone;
  public timeSlotDuration: Record<string, any>[] =
    OPD_CONST.aptTimeSlotDuration;
  public timeSlotFields = OPD_CONST.aptTimeSlotFields;
  public timeSlotCount: number[] = OPD_CONST.aptTimeSlotCount;
  public timeSlotDurationValue = 10;
  public timeSlotCountValue = 1;
  public timeFormatData: Record<string, any>[] = OPD_CONST.aptTimeFormatData;
  public timeFormatValue = OPD_CONST.aptref.time;
  public weekNumberData: Record<string, any>[] = OPD_CONST.aptWeekNumberValue;
  public weekNumberValue = OPD_CONST.aptref.off;
  public eventSettings: EventSettingsModel = {};
  public selectedTarget: Element;
  public menuItems: MenuItemModel[] = OPD_CONST.aptMenuModel;
  public timeScale: TimeScaleModel = OPD_CONST.aptTimeScaleModel;
  weatherData: any;
  toolData: any;
  isReschedule: boolean = false;
  IsRescheduleData: any;
  isHold: boolean = false;
  unHold: boolean = false;
  userRightList: any = [];
  isHoldSplRights: boolean = false;
  isUnHoldSplRights: boolean = false;
  isPermission: boolean = true;
  isDoctorVisible: boolean = true;
  isConsultationVisible:boolean=true;
  isQuickSearch: boolean = true;
  doctorFilteredList: any;
  docList: any;
  patientId: string = "";
  mrn: string = "";
  patientImage: string = "";
  patientInfoDisplay: string = "";
  isDisplayRemarks:boolean=false;
  imageUrl="";
  filteredDocsList:baseObject[] = []; 
  doctorSearch :string= '';
  startdate: number;
  endDate: number;
  isOverRightBlockedSlot: boolean=false;

  slotBlockDuration: number = OPD_CONST.defaultSlotsBlockDuration;
  isFromWaitingList:boolean=false;
  waitingPatient: any;
   viewOptions: any[] = [];
  orgCode: string;
  isRecurringAppointments: boolean= false;

  constructor(
    public dialog: MatDialog,
    public baseservice: AppBaseService,
    public snackBar: MatSnackBar,
    private appoinmentService: AppointmentService,
    public loadingBar: LoadingBarService,
    public datepipe: DatePipe,
    public authService: AuthService,
    public router: Router,
    private route: ActivatedRoute,
    private langService: MultiLanguageService,
    public masterApiService: MasterUrlService,
    public generalApiService: GeneralUrlService,
    private applicationConfigService: ApplicationConfigService,
    private env: EnvoirnmentService
  ) {
    this.subscriptionList.add(
      route.data.subscribe((data) => {
        this.apptType = data[OPD_CONST.aptref.appt];
      })
    );
  }

  /**
   *Load method
   *
   * @memberof PatientAppointmentComponent
   */
  ngOnInit() {
    this.onChanges();
    this.filteredDocsList = this.doctorList;

    this.imageUrl = this.env.apiUrl;
    this.authService.getUnit().then((value: any) => {
      this.unitId = value.unitId;
      this.unitCode = value.unitCode;
      this.orgId = value.orgId;
      this.orgCode = value.orgCode;
      this.getOrgAppConfigList();
    });
    this.authService.getGeneralSettingInfo().then((value: any) => {
      this.blockTime = value.slotTime;
    });
    this.authService.getUserInfo().then((value: any) => {
      this.userRightList = value.userSpecialRightList;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightFreeze)
            this.isHoldSplRights = true;
          if (element.specialRightCode == OPD_CONST.splRightUnFreeze)
            this.isUnHoldSplRights = true;
          if (element.specialRightCode == OPD_CONST.splRightOverRighteBlockedSlot)
            this.isOverRightBlockedSlot = true;
        });
      }
    });

    this.subscriptionList.add(
      this.appointmentTypeDFltrCtrl.valueChanges.subscribe(() => {
        this.filterappointmentType();
      })
    );
    this.subscriptionList.add(
      this.teleFilterCtrl.valueChanges.subscribe(() => {
        this.filterteleconsulation();
      })
    );
    this.getAppointmentTypeMaster();
    this.getTeleApptype();
    this.getAppConfig();
    if (history.state && history.state.patient) {
      this.waitingPatient = history.state.patient;
      this.appointmentType = this.waitingPatient.serviceCategory?.code || '';
      this.appointmentTypeChange(this.appointmentType);
      this.teleconsultaion = this.waitingPatient.consultationType?.code || '';
      this.consultationOnchange(this.teleconsultaion, true);
      this.department = this.waitingPatient.specialty?.[0]?.coding?.[0]?.code || '';
      let departmentvalue={value:this.department}
      this.departmentOnChange(departmentvalue,false);
      this.isFromWaitingList = true;
    } else {
    this.isFromWaitingList=false;
    }
    this.setViewOptions();
  }

   getOrgAppConfigList() {
      let appConfig: any;
       this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
          this.baseservice
            .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
            .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res) {
            appConfig = res.keys;
            appConfig.forEach((element) => {
             
              if (element.key == MasterKeys.allowedRecurringAppointments){
                if (element.valueList?.length > 0 && element.valueList[0]?.code == "true") {
                  this.isRecurringAppointments = true;
              }
            }
          });
          } 
        });
    }  
  /**
   *
   *
   * @memberof PatientAppointmentComponent
   */
  public getAppConfig(): void {
    this.applicationConfigService
      .getModuleConfiguration(OPD_CONST.appConfigPatientManagement)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if(res) {
          let slotsKey = res.find(i => i.key == OPD_CONST.appConfigSlotsBlockDuration);
          this.slotBlockDuration = slotsKey.valueList && slotsKey.valueList.length > 0
            ? slotsKey.valueList[0].numberValue
            : OPD_CONST.defaultSlotsBlockDuration;
        }
      });
  }

  public updateLiveTime(timezone: string = OPD_CONST.aptTimeRef.utc): void {
    this.liveTimeUpdate = new Date().toLocaleTimeString(
      OPD_CONST.aptTimeRef.enus,
      {
        timeZone: timezone,
      }
    );
  }
  
  /**
   * On patient select
   * @param patient patient DTO
   *
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient: PatientDTOObject) {
    this.dataSource = new MatTableDataSource<any>([]);
    this.patient = patient;
    this.patientId = patient.id;
    this.mrn = patient.mrn;
    this.dataSource = new MatTableDataSource<any>();
    var dobFormatted = "";
    var patientAge = "";
    if (patient.dateOfBirth) {
      dobFormatted = this.datepipe.transform(patient.dateOfBirth, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      patient.fullName +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");
    this.patientImage = patient.photo ? patient.photo.url : "";
    this.getAppointmentList();
  }

  /**
   *Change event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWeekDayChange(args: ChangeEventArgs): void {
    this.scheduleObj.firstDayOfWeek = args.value as number;
  }
  /**
   *workweek day change event
   *
   * @param {MultiSelectChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWorkWeekDayChange(args: MultiSelectChangeEventArgs): void {
    this.scheduleObj.workDays = args.value as number[];
  }

  /**
   *Resource change event
   *
   * @param {MultiSelectChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onResourceChange(args: MultiSelectChangeEventArgs): void {
    let resourcePredicate: Predicate;
    const values = args.value.map((item: any) => {
      // Transform `item` to the appropriate type
      return typeof item === 'object' && item.property ? item.property : item;
    });
    for (const value of values) {
      if (resourcePredicate) {
        resourcePredicate = resourcePredicate.or(
          new Predicate(
            OPD_CONST.aptTimeRef.calendarId,
            OPD_CONST.aptTimeRef.equal,
            value
          )
        );
      } else {
        resourcePredicate = new Predicate(
          OPD_CONST.aptTimeRef.calendarId,
          OPD_CONST.aptTimeRef.equal,
          value
        );
      }
    }
    this.scheduleObj.resources[0].query = resourcePredicate
      ? new Query().where(resourcePredicate)
      : new Query().where(
          OPD_CONST.aptTimeRef.calendarId,
          OPD_CONST.aptTimeRef.equal,
          1
        );
  }

  /**
   *On time zone change event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimezoneChange(args: ChangeEventArgs): void {
    this.scheduleObj.timezone = args.value as string;
    this.updateLiveTime(this.scheduleObj.timezone);
    document.querySelector(
      OPD_CONST.aptTimeRef.scheduleoverViewTime
    ).innerHTML = OPD_CONST.aptTimeRef.innerHtml + args.itemData.text;
  }

  /**
   *On Day StartHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onDayStartHourChange(args: TimeEventArgs): void {
    this.scheduleObj.startHour = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }

  /**
   *On Day EndHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onDayEndHourChange(args: TimeEventArgs): void {
    this.scheduleObj.endHour = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }
  /**
   *On work StartHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWorkStartHourChange(args: TimeEventArgs): void {
    this.scheduleObj.workHours.start = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }
  /**
   *On work EndHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWorkEndHourChange(args: TimeEventArgs): void {
    this.scheduleObj.workHours.end = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }
  /**
   *onTimescaleDurationChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimescaleDurationChange(args: ChangeEventArgs): void {
    this.scheduleObj.timeScale.interval = args.value as number;
  }
  /**
   *onTimescaleIntervalChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimescaleIntervalChange(args: ChangeEventArgs): void {
    this.scheduleObj.timeScale.slotCount = args.value as number;
  }
  /**
   *onTimeFormatChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimeFormatChange(args: ChangeEventArgs): void {
    this.scheduleObj.timeFormat = args.value as string;
  }
  /**
   *onWeekNumberChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWeekNumberChange(args: ChangeEventArgs): void {
    if (args.value === OPD_CONST.aptTimeRef.off) {
      this.scheduleObj.showWeekNumber = false;
    } else {
      this.scheduleObj.showWeekNumber = true;
      this.scheduleObj.weekRule = args.value as any;
    }
  }
  /**
   * getResourceData method
   *
   * @param {Record<string, any>} data
   * @return {*}  {Record<string, any>}
   * @memberof PatientAppointmentComponent
   */
  public getResourceData(data: Record<string, any>): Record<string, any> {
    const resources: ResourcesModel =
      this.scheduleObj.getResourceCollections()[0];
    const resourceData: Record<string, any> = (
      resources.dataSource as Record<string, any>[]
    ).filter(
      (resource: Record<string, any>) => resource["CalendarId"] === data["CalendarId"]
    )[0] as Record<string, any>;
    return resourceData;
  }
  /**
   *get header styles method
   *
   * @param {Record<string, any>} data
   * @return {*}  {Record<string, any>}
   * @memberof PatientAppointmentComponent
   */
  public getHeaderStyles(data: Record<string, any>): Record<string, any> {
    if (data["elementType"] === OPD_CONST.aptHeaderStyle.cell) {
      return {
        "align-items": OPD_CONST.aptHeaderStyle.center,
        color: OPD_CONST.aptHeaderStyle.colorCode,
      };
    } else {
      const resourceData: Record<string, any> = this.getResourceData(data);
      let calendarColor = OPD_CONST.aptHeaderStyle.calenderColorCode;
      if (resourceData) {
        calendarColor = resourceData["CalendarColor"].toString();
      }
      return {
        background: calendarColor,
        color: OPD_CONST.aptHeaderStyle.calenderbgColor,
      };
    }
  }
  /**
   *get header method
   *
   * @param {Record<string, any>} data
   * @return {*}  {string}
   * @memberof PatientAppointmentComponent
   */
  public getHeaderTitle(data: Record<string, any>): string {
    return data["elementType"] === OPD_CONST.aptHeaderStyle.cell
      ? OPD_CONST.aptHeaderStyle.addAppointment
      : OPD_CONST.aptHeaderStyle.appointmentDetails;
  }
  /**
   *getHeaderDetails method
   *
   * @param {{ [key: string]: Date }} data
   * @return {*}  {string}
   * @memberof PatientAppointmentComponent
   */
  public getHeaderDetails(data: { [key: string]: Date }): string {
    return (
      this.intl.formatDate(data["StartTime"], {
        type: OPD_CONST.aptHeaderStyle.date,
        skeleton: OPD_CONST.aptHeaderStyle.full,
      }) +
      " (" +
      new Date(data["StartTime"]).toLocaleTimeString() +
      " - " +
      new Date(data["EndTime"]).toLocaleTimeString() +
      ")"
    );
  }
  /**
   *getEventType method
   *
   * @param {{ [key: string]: string }} data
   * @return {*}  {string}
   * @memberof PatientAppointmentComponent
   */
  public getEventType(data: { [key: string]: string }): string {
    const resourceData: Record<string, any> = this.getResourceData(data);
    let calendarText = "";
    if (resourceData) {
      calendarText = resourceData["CalendarText"].toString();
    }
    return calendarText;
  }
  /**
   *on print method
   *
   * @memberof PatientAppointmentComponent
   */
  public onPrintClick(): void {
    this.scheduleObj.print();
  }
  /**
   *export click method
   *
   * @param {*} args
   * @memberof PatientAppointmentComponent
   */
  public onExportClick(args): void {
    if (args.item.text === OPD_CONST.aptref.Excel) {
      let exportDatas: Record<string, any>[] = [];
      const eventCollection: Record<string, any>[] =
        this.scheduleObj.getEvents();
      const resourceCollection: ResourcesModel[] =
        this.scheduleObj.getResourceCollections();
      const resourceData: Record<string, any>[] = resourceCollection[0]
        .dataSource as Record<string, any>[];
      for (const resource of resourceData) {
        const data: Record<string, any>[] = eventCollection.filter(
          (e: Record<string, any>) => e["CalendarId"] === resource["CalendarId"]
        );
        exportDatas = exportDatas.concat(data as Record<string, any>[]);
      }
      this.scheduleObj.exportToExcel({
        exportType: "xlsx",
        customData: exportDatas,
        fields: OPD_CONST.aptExcelDisplay,
      });
    } else {
      this.scheduleObj.exportToICalendar();
    }
  }

  /**
   *popup open issue
   *
   * @param {PopupOpenEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onPopupOpen(args: PopupOpenEventArgs): void {
    if (args.type === OPD_CONST.aptref.quickInfo) {
      this.eventClick(args.data);
    } else if (args.type == OPD_CONST.aptref.editor) {
      args.cancel = true;
    }
  }

  //---------------------------------- sync fusion calendar end -------
  /**
 search method
 *
 * @memberof PatientAppointmentComponent
 */
  initAutoComplete() {
    this.filteredDepts.next(this.departmentList.slice());
    this.subscriptionList.add(
      this.deptFilterCtrl.valueChanges.subscribe(() => {
        this.filterDepts();
      })
    );
    if (this.doctorList.length > 0) {
      this.doctorList.next(this.docList.slice());
      this.subscriptionList.add(
        this.appointmentTypeDFltrCtrl.valueChanges.subscribe(() => {
          this.filterDoc();
        })
      );

      this.subscriptionList.add(
        this.doctorFltrCtrl.valueChanges.subscribe(() => {
          this.filterDocs();
        })
      );
    }
  }

  /**
   *Destroy method
   *
   * @memberof PatientAppointmentComponent
   */
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
    if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
      localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
    if (localStorage.getItem(OPD_CONST.aptref.rescheduleApp)) {
      localStorage.removeItem(OPD_CONST.aptref.rescheduleApp);
    }
    if (localStorage.getItem(OPD_CONST.appoinmentRef.appointmentEncounter)) {
      localStorage.removeItem(OPD_CONST.appoinmentRef.appointmentEncounter);
    }
  }
  /**
   *filter departments method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDepts() {
    if (!this.departmentList) {
      return;
    }
    let search = this.deptFilterCtrl.value;
    if (!search) {
      this.filteredDepts.next(this.departmentList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepts.next(
      this.departmentList.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter doctors method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDoc() {
    if (!this.docList) {
      return;
    }
    let search = this.appointmentTypeDFltrCtrl.value;
    if (!search) {
      this.doctorList.next(this.docList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.doctorList.next(
      this.docList.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter teleconsulation list
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterteleconsulation() {
    if (!this.Teleconsultations) {
      return;
    }
    let search = this.teleFilterCtrl.value;
    if (!search) {
      this.filteredTelecom.next(this.Teleconsultations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTelecom.next(
      this.Teleconsultations.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter appointmetn Type method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterappointmentType() {
    if (!this.appointmentTypeList) {
      return;
    }
    let search = this.appointmentTypeDFltrCtrl.value;
    if (!search) {
      this.filteredappointmentType.next(this.appointmentTypeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredappointmentType.next(
      this.appointmentTypeList.filter(
        (e) => e.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *get filter docs
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDocs() {
    if (!this.doctorList) {
      return;
    }
    let search = this.doctorFltrCtrl.value;
    if (!search) {
      this.filteredDocs.next(this.doctorList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDocs.next(
      this.doctorList.filter(
        (dept) => dept.name.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *after view intit
   *
   * @memberof PatientAppointmentComponent
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.currentDate = this.setDateHeader();
    }, 500);
  }
  /**
   *get appointment list method
   *
   * @memberof PatientAppointmentComponent
   */
   private getStartOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = day === 0 ? 0 : day; 
    return new Date(date.setDate(date.getDate() - diff));
  }
  
  private getEndOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = day === 0 ? 6 : 6 - day;
    return new Date(date.setDate(date.getDate() + diff));
  }
  public getAppointmentList(values?) {
    let startDate: number, endDate: number;
  
    if (values) {
      const currentDate = new Date(values.currentDate || new Date());
      startDate = Math.floor(this.getStartOfWeek(currentDate).getTime() / 1000); 
      endDate = Math.floor(this.getEndOfWeek(currentDate).setHours(23, 59, 59, 999) / 1000);    
    } else {
      setTimeout(() => {
        const currentViewDates: Date[] = this.scheduleObj.getCurrentViewDates() as Date[];
        const viewStart: Date = currentViewDates[0];
        const viewEnd: Date = currentViewDates[currentViewDates.length - 1];
    
        startDate = Math.floor(this.getStartOfWeek(viewStart).getTime() / 1000); 
        endDate = Math.floor(this.getEndOfWeek(viewEnd).setHours(23, 59, 59, 999) / 1000);   
      }, 1000);
    }
  
    const aptmentTypeValue = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
  setTimeout(() => {
    let url;
    if (
      aptmentTypeValue.code == OPD_CONST.aptref.apttypeDeptCode ||
      aptmentTypeValue.code == OPD_CONST.aptref.apttTypeHscCode
    ) {
      url = this.appoinmentService.setURlslotData(this, startDate, endDate);
    } else {
      url = this.appoinmentService.setURLmultipleDoctor(this, startDate, endDate);
    }
  
    if (aptmentTypeValue.id) {
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.OPD_SERVICE, url)
          .subscribe((res: any[]) => {
            this.allSlots = res;
            this.events = [];
            if (res != null && res.length > 0) {
              this.weekView(res);
            } else {
              this.setOverViewData(this.events);
            }
          })
      );
    }
  }, 1000);
   
  }
  /**
   *change single to multiple
   *
   * @memberof PatientAppointmentComponent
   */
  changeSingleToMultiple() {
    if (!this.mulipleDoctor) {
      this.apptType = OPD_CONST.aptref.resource;
    } else {
      this.doctorList.forEach((element) => {
        element.slected = "";
      });
      this.multipleDoctorSlected = [];
      this.parentMessage = {
        res: [],
        appointmentType: this.appointmentType,
        doctor: this.activeDoctor,
        department: this.department,
        currentDate: this.currentDate,
      };
      this.apptType = OPD_CONST.aptref.appt;
    }
  }
  /**
   *
   */
  appoinmentSearch() {
    let aptmentTypeDesc = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
    const dialogRef = this.dialog.open(AppointmentQuickSearchComponent, {
      height: "550px",
      width: "550px",
      data: {
        appointmentType: this.appointmentType,
        doctor: this.activeDoctor,
        department: this.department,
        doctorList: this.multiLangDoctorList,
        appointmentDate: OPD_CONST.aptref.selectedDate,
        slotMinutes: OPD_CONST.aptref.slotMints,
        aptmentTypeDesc: aptmentTypeDesc,
        consultationtype: this.teleconsultaion,
        consultationtypeList: this.Teleconsultations,
        departmentList: this.departmentList,
        appointmentTypeList: this.appointmentTypeList,
      },
    });
    this.subscriptionList.add(dialogRef.afterClosed().subscribe(() => {}));
  }
  /**
   *change multipe doctors
   *
   * @memberof PatientAppointmentComponent
   */
  getMultipleDoctors() {
    this.currentDate = this.datepipe.transform(
      new Date(),
      OPD_CONST.aptref.dateFormat
    );
    var docs: any[] = [];
    this.multipleDoctorSlected.forEach((element) => {
      docs.push(element.code);
    });

    if (this.appointmentType.id) {
      let start = (
        new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
      ).toFixed(0);
      let end = (
        new Date(new Date().setHours(23, 59, 0, 0)).getTime() / 1000
      ).toFixed(0);
      let url = this.appoinmentService.setURLmultipleDoctor(this, start, end);
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.OPD_SERVICE, url)
          .subscribe((res) => {
            this.parentMessage = {
              res: res,
              appointmentType: this.appointmentType,
              doctor: this.activeDoctor,
              department: this.department,
              currentDate: this.currentDate,
            };
            this.multipleDoctors = res[0].Slots;
          })
      );
    }
  }
  /**
   *Display WeekWise Slot
   *
   * @param {*} data
   * @memberof PatientAppointmentComponent
   */
  weekView(data) {
    let teleConsultaionValue = this.Teleconsultations.find(
      (i) => i.code == this.teleconsultaion
    );
    
    data.forEach((eachDay) => {
      eachDay.Slots.forEach((slot) => {
        if (slot.businessStatus == OPD_CONST.aptSlotStatus.busy) {
          var mrn: any[] = [];
          var apt: any[] = [];
          if (slot.patientNumber) {
            slot.patientNumber.forEach((element) => {
              if (element.type) {
                mrn.push(element.type.text);
                apt.push({ mar: element.type.text, apptNo: element.value });
              }
            });
          }
          this.events.push({
            subjectHeader: "Subject ",
            Subject: OPD_CONST.aptSlotStatus.mrn + mrn.toString(),
            StartTime: new Date(slot.start),
            EndTime: new Date(slot.end),
            IsAllDay: false,
            CalendarId: 3,
            Location: "",
            Description: OPD_CONST.aptSlotStatus.eventBooked,
            Id: slot.id,
          });
        } else if (
          slot.businessStatus.toUpperCase() ==
          OPD_CONST.aptSlotStatus.Hold.toUpperCase()
        ) {
          var reason = slot.hold ? slot.hold.reason[0].display : "";
          var remarks = slot.hold ? slot.hold.remarks : "";
          this.isDisplayRemarks=true;
          this.events.push({
            subjectHeader: "Reason ",
            Subject:reason ,
            remarks:remarks,
            StartTime: new Date(slot.start),
            EndTime: new Date(slot.end),
            DepartmentName: this.department,
            Id: slot.id,
            IsAllDay: false,
            CalendarId: 4,
            Location: "",
            Description: OPD_CONST.aptSlotStatus.eventScheduled,
          });
        } else if (
          slot.businessStatus.toUpperCase() ==
          OPD_CONST.aptSlotStatus.free.toUpperCase()
        ) {
          var currentTime = new Date().getTime() / 1000;
          var currentSlotBlockTime = Number((currentTime + (this.slotBlockDuration*60)));
    
          let aptmentTypeValue = this.appointmentTypeList.find(
            (i) => i.code == this.appointmentType
          );
          if (
            currentTime > slot.startDateTimeEpoch &&
            aptmentTypeValue.code != OPD_CONST.aptref.apttTypeHscCode
          ) {
            var mrn: any[] = [];
            var apt: any[] = [];
            if (slot.patientNumber) {
              slot.patientNumber.forEach((element) => {
                mrn.push(element.display);
                apt.push({ mar: element.display, apptNo: element.reference });
              });
            }
            this.events.push({
              subjectHeader: "Subject ",
              Subject: teleConsultaionValue.desc,
              StartTime: new Date(slot.start),
              EndTime: new Date(slot.end),
              DepartmentName: this.department,
              Id: slot.id,
              IsAllDay: false,
              CalendarId: 2,
              Location: "",
              Description: OPD_CONST.aptSlotStatus.eventScheduled,
            });
          } else if (
            currentTime > slot.endDateTimeEpoch &&
            aptmentTypeValue.code == OPD_CONST.aptref.apttTypeHscCode
          ) {
            var mrn: any[] = [];
            var apt: any[] = [];
            if (slot.patientNumber) {
              slot.patientNumber.forEach((element) => {
                mrn.push(element.display);
                apt.push({ mar: element.display, apptNo: element.reference });
              });
            }
            this.events.push({
              subjectHeader: "Subject ",
              Subject: teleConsultaionValue ? teleConsultaionValue.desc : "",
              StartTime: new Date(slot.start),
              EndTime: new Date(slot.end),
              DepartmentName: this.department,
              Id: slot.id,
              IsAllDay: false,
              CalendarId: 2,
              Location: "",
              Description: OPD_CONST.aptSlotStatus.eventScheduled,
            });
          } else if(slot.startDateTimeEpoch < currentSlotBlockTime) {
            this.events.push({
              subjectHeader: "Subject ",
              Subject: OPD_CONST.aptSlotStatus.blocked,
              StartTime: new Date(slot.start),
              EndTime: new Date(slot.end),
              IsAllDay: false,
              CalendarId: 4,
              Location: "",
              Description: OPD_CONST.aptSlotStatus.eventBooked,
              Id: slot.id,
            });
            slot.tempStatus=OPD_CONST.aptSlotStatus.blocked;
          } else {
            var minutesToAdd = this.blockTime;
            var currentDate = new Date();
            var currentTimeappconfig =
              Number(new Date(currentDate.getTime() + minutesToAdd * 60000)) /
              1000;
            if (
              currentTimeappconfig > slot.startDateTimeEpoch &&
              aptmentTypeValue.code != OPD_CONST.aptref.apttTypeHscCode
            ) {
              var mrn: any[] = [];
              var apt: any[] = [];
              if (slot.patientNumber) {
                slot.patientNumber.forEach((element) => {
                  mrn.push(element.display);
                  apt.push({ mar: element.display, apptNo: element.reference });
                });
              }
              this.events.push({
                subjectHeader: "Subject ",
                Subject: teleConsultaionValue.desc,
                StartTime: new Date(slot.start),
                EndTime: new Date(slot.end),
                Id: slot.id,
                IsAllDay: false,
                CalendarId: 2,
                Location: "",
                Description: OPD_CONST.aptSlotStatus.eventScheduled,
                DepartmentName: this.department.desc,
              });
            } else {
              var mrn: any[] = [];
              var apt: any[] = [];
              if (slot.patientNumber) {
                slot.patientNumber.forEach((element) => {
                  mrn.push(OPD_CONST.aptSlotStatus.mrn + element.type.text);
                  apt.push({ mar: element.type.text, apptNo: element.value });
                });
              }
              this.events.push({
                subjectHeader: "Subject ",
                Subject:
                  mrn.length > 0
                    ? mrn.toString()
                    : teleConsultaionValue
                    ? teleConsultaionValue.desc
                    : "",
                StartTime: new Date(slot.start),
                EndTime: new Date(slot.end),
                Id: slot.id,
                IsAllDay: false,
                CalendarId: 1,
                Location: "",
                Description: OPD_CONST.aptSlotStatus.eventScheduled,
                DepartmentName: this.department.desc,
              });
            }
          }
        }
      });
    });
    this.setOverViewData(this.events);
  }
  /**
   *set over view data
   *
   * @param {any[]} events
   * @memberof PatientAppointmentComponent
   */
  setOverViewData(events: any[]) {
    const overviewEvents: { [key: string]: Date }[] = extend(
      [],
      events,
      null,
      true
    ) as { [key: string]: Date }[];
    const timezone: Timezone = new Timezone();
    const utcTimezone: never = OPD_CONST.aptref.utc as never;
    const currentTimezone: never = timezone.getLocalTimezoneName() as never;
    for (const event of overviewEvents) {
      event["StartTime"] = timezone.convert(
        event["StartTime"],
        utcTimezone,
        currentTimezone
      );
      if (event["EndTime"]) {
        event["EndTime"] = timezone.convert(
          event["EndTime"],
          utcTimezone,
          currentTimezone
        );
      }
    }
    this.eventSettings = { dataSource: overviewEvents };
  }
  /**
   *event clcik method
   *
   * @param {*} jsEvent
   * @memberof PatientAppointmentComponent
   */
  eventClick(jsEvent) {
    let currentDate =new Date();
    if(this.isOverRightBlockedSlot && jsEvent.CalendarId != 3 && jsEvent.CalendarId != 1 && !this.unHold && !this.isHold
      && jsEvent.StartTime>=currentDate
    ){
      let aptmentTypeDesc = this.appointmentTypeList.find(
        (i) => i.code == this.appointmentType
      );
      let dateId=this.datepipe.transform(jsEvent.StartTime, 'yyyy-MM-dd');
      var slots: any[] = [];
      this.allSlots.forEach((element) => {
        if (element._id == dateId) {
          slots = element.Slots;
        }
      });
      const dialogRef = this.dialog.open(DialogAddAppointmentPatient, {
        width: OPD_CONST.aptref.width,
        height:"auto",
        data: {
          appointmentDate: OPD_CONST.aptref.selectedDate,
          slotMinutes: OPD_CONST.aptref.slotMints,
          slotId: jsEvent.Id,
          selectedDay: dateId,
          daySlot: slots,
          appointmentType: this.appointmentType,
          aptmentTypeDesc: aptmentTypeDesc,
          doctor: this.activeDoctor,
          department: this.department,
          consultationtype: this.teleconsultaion,
          consultationtypeList: this.Teleconsultations,
          calenderEvent: jsEvent,
          doctorList: this.multiLangDoctorList,
          departmentList: this.departmentList,
          appointmentTypeList: this.appointmentTypeList,
          blocktime: (this.slotBlockDuration * 60),
          reScheduleData: this.isReschedule ? this.IsRescheduleData : "",
          waitingPatient:this.waitingPatient
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe(() => {
          this.getAppointmentList();
        })
      );
    }else{
    if (
      (jsEvent.CalendarId == 1 && jsEvent.Id) ||
      (jsEvent.CalendarId == 4 && jsEvent.Id)
    ) {
      if (this.isHold) {
        if (jsEvent.CalendarId != 4) {
          const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
            width: "20%",
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe((result) => {
              if (result.action == "yes") {
                let reqpaylad = {
                  ids: [jsEvent.Id ? jsEvent.Id : 0],
                  remarks: result.remarks ? result.remarks : "",
                  reason: result.reason
                    ? this.langService.createObjectList(result.reason[0])
                    : [],
                  status: "HOLD",
                };
                this.subscriptionList.add(
                  this.generalApiService
                    .putTypeApi(
                      OPD_API_URL.OPD_SERVICE,
                      OPD_API_URL.OPD_APPOINTMENT_HOLD,
                      reqpaylad
                    )
                    .subscribe((response: any) => {
                      if (response) {
                        this.snackBar.open(
                          this.langService.get("CommonAppoinment.success"),
                          "Hold Slot Successfully",
                          {
                            duration: 3000,
                          }
                        );
                      }
                      this.getAppointmentList();
                    })
                );
              }
            })
          );
        }
      } else if (this.unHold) {
        if (jsEvent.CalendarId == 4) {
          const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
            width: "20%",
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe((result) => {
              if (result.action == "yes") {
                let reqpaylad = {
                  ids: [jsEvent.Id ? jsEvent.Id : 0],
                  remarks: result.remarks ? result.remarks : "",
                  reason: result.reason
                    ? this.langService.createObjectList(result.reason[0])
                    : [],
                  status: "UNHOLD",
                };
                this.subscriptionList.add(
                  this.generalApiService
                    .putTypeApi(
                      OPD_API_URL.OPD_SERVICE,
                      OPD_API_URL.OPD_APPOINTMENT_HOLD,
                      reqpaylad
                    )
                    .subscribe((response: any) => {
                      if (response) {
                        this.snackBar.open(
                          this.langService.get("CommonAppoinment.success"),
                          "UnHold Slot Successfully",
                          {
                            duration: 3000,
                          }
                        );
                      }
                      this.getAppointmentList();
                    })
                );
              }
            })
          );
        } else {
          this.snackBar.open(
            this.langService.get("CommonAppoinment.warning"),
            "Please Selct the Hold slots only",
            {
              duration: 3000,
            }
          );
        }
      } else {
        if (jsEvent.CalendarId != 4) {
          let aptmentTypeDesc = this.appointmentTypeList.find(
            (i) => i.code == this.appointmentType
          );
          // let dateId = this.datepipe.transform(
          //   jsEvent.StartTime,
          //   OPD_CONST.aptref.jsDateFormat
          // );
          let dateId=this.datepipe.transform(jsEvent.StartTime, 'yyyy-MM-dd');
          var slots: any[] = [];
          this.allSlots.forEach((element) => {
            if (element._id == dateId) {
              slots = element.Slots;
            }
          });
          debugger;
          const dialogRef = this.dialog.open(DialogAddAppointmentPatient, {
            width: OPD_CONST.aptref.width,
            height:"auto",
            data: {
              appointmentDate: OPD_CONST.aptref.selectedDate,
              slotMinutes: OPD_CONST.aptref.slotMints,
              slotId: jsEvent.Id,
              selectedDay: dateId,
              daySlot: slots,
              appointmentType: this.appointmentType,
              aptmentTypeDesc: aptmentTypeDesc,
              doctor: this.activeDoctor,
              department: this.department,
              consultationtype: this.teleconsultaion,
              consultationtypeList: this.Teleconsultations,
              calenderEvent: jsEvent,
              doctorList: this.multiLangDoctorList,
              departmentList: this.departmentList,
              appointmentTypeList: this.appointmentTypeList,
              blocktime: (this.slotBlockDuration * 60), //this.minutesblock,
              reScheduleData: this.isReschedule ? this.IsRescheduleData : "",
              waitingPatient:this.waitingPatient
            },
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe(() => {
              this.getAppointmentList();
            })
          );
        }
      }
    } else if (jsEvent.CalendarId == 3) {
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_APPOINTMENT_FILTER + jsEvent.event.apptNo[0].apptNo
          )
          .subscribe((res) => {
            this.details = {
              name: res[0].subject.display,
              gender: res[0].temporaryPatient[0].gender.desc,
              doctor: res[0].entity.display,
              department: res[0].specialty[0].text,
              appointment: res[0].start,
              mrnNumber: res[0].temporaryPatient[0].TRN,
              mobile: res[0].temporaryPatient[0].mobileNo,
              photo: res[0].temporaryPatient[0].photo,
              id: res[0].temporaryPatient[0].idType.desc,
              idno: res[0].temporaryPatient[0].idNumber,
              email: res[0].temporaryPatient[0].email,
              company: res[0].company ? res[0].company.display : "",
              ref: res[0].referralEntityType
                ? res[0].referralEntityType.display
                : "",
              refType: res[0].referralEntityName
                ? res[0].referralEntityName.display
                : "",
              bookingType: res[0].bookingType ? res[0].bookingType.display : "",
              appno: res[0].identifier[0].value,
            };

            this.dialog.open(AppointmentDetailsComponent, {
              width: OPD_CONST.aptref.dialogWidth,
              data: {
                details: this.details,
                allAppointment: jsEvent.event.apptNo,
              },
            });
          })
      );
    } else {
      if (jsEvent.Id) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.slotIsAlreadybooked"),
          {
            duration: 3000,
          }
        );
      }
    }
  }
  }
  /**
   *set date header method
   *
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  setDateHeader() {
    const elementHead = document.getElementsByClassName(
      OPD_CONST.aptref.fcCenter
    )[0];
    if (elementHead) {
      this.currentDate = elementHead.children.item(0).innerHTML;
      return elementHead.children.item(0).innerHTML;
    }
  }
  /**
   *seclet type method
   *
   * @memberof PatientAppointmentComponent
   */
  selectType() {
    let rescheduleData = JSON.parse(
      localStorage.getItem(OPD_CONST.appoinmentRef.aptResData)
    );
    this.appointmentType = this.appointmentTypeList.find(
      (i) => i.code == rescheduleData.appointmentType
    );
    this.appointmentTypeChange(Number(this.appointmentType.code));
    this.checkRequestHasRecschedule();
  }
  /**
   *appointment type change method
   *
   * @param {*} event
   * @memberof PatientAppointmentComponent
   */
  public appointmentTypeChange(value) {
    this.activeDoctor.code = "";
    this.activeDoctor.id = "";
    this.activeDoctor.name = "";
    this.activeDoctor.department = "";
    this.activeDoctor.email = "";
    this.doctorList = [];
    this.multiLangDoctorList = [];
    this.doctorsCount = "";
    this.events = [];
    this.setOverViewData(this.events);
    if (value == 1) {
      this.doctorList = [];
      this.multiLangDoctorList = [];
      this.multiDocCheckbox = false;
      this.teleconsultaion = {};
      this.multiDocCheckbox = true;
      this.department = {};
      this.isConsultationVisible=true;
    } else {
      this.doctorList = [];
      this.multiLangDoctorList = [];
      this.teleconsultaion = {};
      this.department = {};
    }

    if (value == 3) {
      this.isPermission = false;
      this.isDoctorVisible = false;
      this.isConsultationVisible=false;
      this.getDepartment(false);
    } else if (value == 2) {
      this.isPermission = true;
      this.isDoctorVisible = false;
      this.isConsultationVisible=true;
    } else
    {  
      this.isPermission = true;
      this.isDoctorVisible = true;
      this.isConsultationVisible=true;
    }
  }

  /**
   *consultaoin change method
   *
   * @param {*} teleconsultaion
   * @param {*} isReschedule
   * @memberof PatientAppointmentComponent
   */
  public consultationOnchange(teleconsultaion, isReschedule) {
    if (isReschedule) {
      teleconsultaion == OPD_CONST.aptref.clinicCode
        ? this.getDepartment(false)
        : this.getDepartment(true);
    } else {
      if (teleconsultaion.value == OPD_CONST.aptref.clinicCode) {
        this.getDepartment(false);
        this.multiDocCheckbox = true;
      } else {
        this.getDepartment(true);
        this.multiDocCheckbox = true;
      }
    }
  }

  /**
   *get appointmenttype master data
   *
   * @memberof PatientAppointmentComponent
   */
  public getAppointmentTypeMaster() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_APPOINTEMENT_TYPE,true)
        .subscribe((data: any) => {
          this.appointmentTypeList = data;
          this.filteredappointmentType.next(this.appointmentTypeList.slice());

          if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
            this.selectType();
        })
    );
  }
  /**
   *get appointmentTeleconsultation master data
   *
   * @memberof PatientAppointmentComponent
   */
  getTeleApptype() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_TELE_APPOINTMENT_TYPE,true)
        .subscribe((data: any) => {
          this.Teleconsultations = data;
          this.filteredTelecom.next(this.Teleconsultations.slice());
        })
    );
  }
  /**
   *get department master data
   *
   * @param {*} isClinicConsultation
   * @memberof PatientAppointmentComponent
   */
  public getDepartment(isClinicConsultation) {
    this.customArray = [];
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_DEPT)
        .subscribe((data) => {
          if (data && data.length > 0) {
            isClinicConsultation == true
              ? (this.departmentList = data.filter((i) => i.isTeleconsultation))
              : (this.departmentList = data);
          }
          if (data != null && data.length > 0) {
            this.initAutoComplete();
            this.selectDepartment();
            this.filteredDepts.next(this.departmentList.slice());
          }
        })
    );
  }

  public getDepartmentValue(isClinicConsultation) {
    this.customArray = [];
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_DEPT)
        .subscribe((data) => {
          if (data && data.length > 0) {
            isClinicConsultation == true
              ? (this.departmentList = data.filter((i) => i.isTeleconsultation))
              : (this.departmentList = data);
          }
        })
    );
  }
  /**
   *select department method
   *
   * @memberof PatientAppointmentComponent
   */
  selectDepartment() {
    if (localStorage.getItem(OPD_CONST.aptref.rescheduleApp)) {
      const appointment = JSON.parse(
        localStorage.getItem(OPD_CONST.aptref.rescheduleApp)
      );
      this.department = this.departmentList.find(
        (i) => i.desc == appointment.specialty
      );
      this.department.value = {
        code: this.department.code,
      };
    }
  }

  onChanges() {
    if (this.doctorList.length > 0) {
      this.subscriptionList.add(
        this.deptFilterCtrl.valueChanges.subscribe((value) => {
          this.doctorFilteredList = this.docList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        })
      );
      this.subscriptionList.add(
        this.appointmentTypeDFltrCtrl.valueChanges.subscribe((value) => {
          this.doctorList = this.docList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        })
      );
    }
  }
  /**
   *department change method
   *
   * @param {*} department
   * @param {*} isReschedule
   * @memberof PatientAppointmentComponent
   */
  public departmentOnChange(department, isReschedule) {
    this.deptFlag = true;
    this.isQuickSearch = false;
    if (this.appointmentType == OPD_CONST.aptref.aptTypeCode) {
      let payload;
      if (isReschedule) {
        payload = {
          limit: 0,
          unitCode: this.unitCode,
          departmentCode: department,
          isIncludeDoctorSlot: true,
          typeCodeList: ["DR"]
        };
      } else {
        payload = {
          limit: 0,
          unitCode: this.unitCode,
          departmentCode: department.value,
          isIncludeDoctorSlot: true,
          typeCodeList: ["DR"]
        };
      }
      this.subscriptionList.add(
        this.masterApiService
          .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST_NEW, payload)
          .subscribe((content: any) => {
            let data =
              content.payload && content.payload.employeeResponseList
                ? content.payload.employeeResponseList
                : [];
            let list = [];
            let letmultilangdoclist = [];
            if (data != null && data.length > 0) {
              data.forEach((element) => {
                list.push({
                  id: element.id,
                  code: element.code,
                  desc: element.desc,
                  gender:element.gender.toUpperCase(),
                 // imagePath: this.getImage(element.empImagePath, element.code),
                 imagePath:element.aws3FilePath ? element.aws3FilePath : (element.empImagePath ?this.imageUrl+element.empImagePath : ""),
                 available:
                    element.doctoreAvailable == OPD_CONST.noSlotsAvailable
                      ? this.langService.get("AppointmentListPage.noSlotsAvailable")
                      : this.langService.get("AppointmentListPage.nextAvailability") + element.doctoreAvailable,
                  doctoreAvailableDate:element.doctoreAvailable
                });
                letmultilangdoclist.push(element);
              });
            }
            this.multiLangDoctorList = letmultilangdoclist;
            this.doctorFilteredList = list;
            this.doctorList = list;
            this.docList = list;
            this.doctorsCount =
              this.doctorList.length > 0 ? this.doctorList.length : "";
      
              this.filteredDocsList = [...this.doctorList];
            this.filteredDocs.next(this.doctorList.slice());
            let docValue
            if (isReschedule) {
              docValue = this.doctorList.find(
                (i) => i.code == this.IsRescheduleData.doctorCode
              );
              this.doctorOnChange(docValue);
            } else   if(this.isFromWaitingList){
              docValue=this.doctorList.find(
                (i) => i.code == this.waitingPatient.doctor.code
              );
              this.doctorOnChange(docValue);
            }else{
              this.refreshSchedule();
            }
            
          })
      );
    } else {
      this.getAppointmentList();
    }
  }

  filterDoctorList(): void {
    const search = this.doctorSearch.toLowerCase();

    if (!search) {
      this.filteredDocsList = this.doctorList;
      return;
    }

    this.filteredDocsList = this.doctorList.filter((doctor) =>
      doctor.desc.toLowerCase().includes(search)
    );
  }
  /**
   *
   * @param path
   * @param code
   */
  getImage(path, code) {
    if (path) {
      let resPath = path.replace("/file-service/", "");
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.FILE_SERVICE, resPath)
          .subscribe((res: any) => {
            if (res) {
              this.doctorList.forEach((element) => {
                if (element.code == code) {
                  element.imagePath = res.url ? res.url : "";
                }
              });
            }
          })
      );
    }
  }
  /**
   *doctor change method
   *
   * @param {*} doctor
   * @memberof PatientAppointmentComponent
   */
  public doctorOnChange(doctor) {
    if (this.mulipleDoctor) {
      doctor.slected = OPD_CONST.aptref.active;
      var slecteDoctors = this.doctorList.filter((doctor) => {
        return doctor.slected == OPD_CONST.aptref.active;
      });
      this.multipleDoctorSlected = slecteDoctors;
      this.getMultipleDoctors();
    } else {
      this.deptFlag = false;
      this.activeDoctor.id = doctor.id;
      this.activeDoctor.code = doctor.code;
      this.activeDoctor.name = doctor.desc;
      this.activeDoctor.email = doctor.email ? doctor.email : "";
      this.doctor = doctor;
      this.searchResult.doctor = doctor.name;
      const availableDate = this.parseAvailableDate(doctor.doctoreAvailableDate);

      if (availableDate) {
        this.scheduleObj.selectedDate = availableDate;
        this.getAppointmentList({ currentDate: availableDate });
      }
      else {
        this.refreshSchedule();
      }
  }
  }
  parseAvailableDate(dateStr: string): Date | null {
    const match = dateStr.match(/(\w+),(\w+ \d+)/);
    if (!match) {
      return null;
    }
    const currentYear = new Date().getFullYear();
    const formattedDateStr = `${match[2]} ${currentYear}`;
    const parsedDate = new Date(formattedDateStr);
  
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }
  public refreshSchedule() {
    this.allSlots = []; 
    this.events = [];
    const currentDate = new Date();
    this.scheduleObj.selectedDate = new Date(currentDate);
    this.scheduleObj.refresh(); 
    this.setOverViewData(this.events);
   
  }
  /**
   *time stamp method
   *
   * @param {*} strDate
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum / 1000;
  }
  /**
   *Check reques appoinment
   *
   * @memberof PatientRegistrationComponent
   */
  checkRequestHasRecschedule() {
    if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData)) {
      let appointment: any = JSON.parse(
        localStorage.getItem(OPD_CONST.appoinmentRef.aptResData)
      );
      if (appointment && appointment.type == OPD_CONST.appoinmentRef.temp) {
        this.isReschedule = true;
        this.appointmentType = appointment.appointmentType;
        this.teleconsultaion = "CC";
        this.consultationOnchange(this.teleconsultaion, true);
        this.department = appointment.departmentCode;
        this.departmentOnChange(this.department, true);
        this.IsRescheduleData = appointment;
      } else if (
        appointment &&
        appointment.type == OPD_CONST.appoinmentRef.reg
      ) {
        this.isReschedule = true;
        this.appointmentType = appointment.appointmentType;
        this.teleconsultaion = "CC";
        this.consultationOnchange(this.teleconsultaion, true);
        this.department = appointment.departmentCode;
        this.departmentOnChange(this.department, true);
        this.IsRescheduleData = appointment;
      }
    }
  }

  recurringAppointments(){
    let aptmentTypeDesc = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
    let dateId=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    var slots: any[] = [];
    this.allSlots.forEach((element) => {
      if (element._id == dateId) {
        slots = element.Slots;
      }
    });

    const dialogRef = this.dialog.open(RecurringAppointmentsComponent, {
      width: OPD_CONST.aptref.width,
      height:"auto",
      data: {
        appointmentDate: OPD_CONST.aptref.selectedDate,
        slotMinutes: OPD_CONST.aptref.slotMints,
        slotId: 0,
        selectedDay: dateId,
        daySlot: this.allSlots,
        appointmentType: this.appointmentType,
        aptmentTypeDesc: aptmentTypeDesc,
        doctor: this.activeDoctor,
        department: this.department,
        consultationtype: this.teleconsultaion,
        consultationtypeList: this.Teleconsultations,
        calenderEvent: null,
        doctorList: this.multiLangDoctorList,
        departmentList: this.departmentList,
        appointmentTypeList: this.appointmentTypeList,
        blocktime: (this.slotBlockDuration * 60),
        reScheduleData: this.isReschedule ? this.IsRescheduleData : "",
        waitingPatient:this.waitingPatient
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.getAppointmentList();
      })
    );
  }

   setViewOptions(): void {
    this.langService.translate.stream([
      'Scheduler.Day',
      'Scheduler.Week',
      'Scheduler.WorkWeek',
      'Scheduler.Month'
    ]).subscribe(translations => {
      this.viewOptions = [
        { option: 'Day', label: translations['Scheduler.Day'] },
        { option: 'Week', label: translations['Scheduler.Week'] },
        { option: 'WorkWeek', label: translations['Scheduler.WorkWeek'] },
        { option: 'Month', label: translations['Scheduler.Month'] }
      ];
    });
  }
}

export class SearchControl {
  type: string = "";
  placeholder: string = "";
  value: any = {};
  column: number = 6;
  name: string = "";
  url: string = "";
  selectType: string = "";
  radios: string = "";
  methodName: string = "";
  options: any[] = [];
  masterList: any[] = [];
  searchValue:string="";
  isTodaysDate:string="";
}

@Component({
  selector: "app-dilog",
  templateUrl: "./appt-form.html",
  styleUrls: ["./appt-form.scss"],
  providers: [DatePipe],
})
export class DialogAddAppointmentPatient implements OnInit, OnDestroy {
   _onDestroy: Subject<boolean> = new Subject<boolean>();
  primaryIdList: any[] = [];
  slotId: string;
  slotLoadFlag = true;
  patientType = "new";
  selectedDate = "";
  values: any = {};
  saveAction: boolean = false;
  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  maxDate = new Date(this.year, this.month, this.day);
  public isPatientNew = true;
  public disableForm = false;
  primaryIdRegex: string = "[A-Za-z0-9]*";
  appointmentForm: FormGroup ;
  public patient: any = {};
  public environment: any = opdEnvironment;
  public mobile = "";
  public patientId = "";
  public isReschedule = false;
  timeSlotList: any = [];
  timeSlotsArray: any = [];
  breakTimes: any = [];
  passD = new Date();
  passYear = this.passD.getFullYear();
  minDateexp = new Date();
  maxDateexp = new Date(this.passYear + 11, 0, 0);
  unitId: any;
  unitCode: any;
  orgId: any;
  appointmentDate: any;
  resultFound: boolean = false;
  displayedColumns: any;
  dataSource = new MatTableDataSource<any>();
  recordsLength: any;
  searchList: any[];
  patientList: any;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  countryValue: any = null;
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  public dropdownValues: any = {};
  slectedSlotId: any[] = [];
  idNumberLength: any = "14";
  error: any = { isError: false, errorMessage: "" };
  bookingDetails: any;
  private subscriptionList = new Subscription();
  apptType: any;
  dilogData: any;
  selectedSlots: any = {};
  dayslots: any[] = [];
  langValue: string = "";
  masterAPI: any = MASTERSSERVICES;
  showExpirDatePicker: boolean = false;
  isHsc: boolean = false;
  patientSearch: FormControl = new FormControl();
  patientFilter: any[] = [];
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subdistPrimaryList: any[] = [];
  genderValue: any = null;
  primaryValue: any = null;
  prefixValue: any = null;
  specialReq: any;
  mobileCodeValue: any = null;
  date = new Date();
  mindate = new Date(1920, 0, 1);
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0",
    months: "0",
    days: "0",
  };
  autoRescheduleData: any;
  FormRequiredFelds: any = {
    emailRequired: false,
    handphoneRequired: false,
    officeRequired: false,
    homeReqired: false,
    patientRequired: false,
    bookingTypeRequired: false,
    refTypeRequired: false,
    refRequired: false,
    companyRequired: false,
    subSepcilityRequired: false,
  };
  Data: Array<any> = [];
  checkArray: any[] = [];
  selectedPatient: any;
  patientTypeCat: any = OPD_CONST.aptref.new;
  reschRemarks: any;
  reason: any;
  reasonList: any[] = [];
  base64textString: any;
  imageUser: any;
  healthPackageList: any[] = [];
  healthPackage: any;
  checkedPackageList: any[] = [];
  primaryIdentifierListModified: boolean = false;
  patientInfoDisplay: string = "";
  searchCriteria: any = null;
  refreshTime: string = "";
  hidePatientSearch = false;
  isPatientEditRights: boolean = false;
  isRegistered: boolean = false;
  patientImage: any;
  mrn: string;
  isDisabled: boolean = false;
  isVip:boolean=false;
  isNoteVisible?:string
  specialReqList:any=[]=[];
  patientData:boolean=false;
  reasons: any[]=[];
  reasonSearch: FormControl = new FormControl();
  mobileNoMax: number=14;
  mobileNoMin: number=8;
  defaultGender: dataObj;
  prefixCodeList: baseObj[] = [];
  gender: string;
  isOverRightBlockedSlot: boolean=false;
  loadingData: boolean=false;
  offset: number=0;
  limit: number=10;
  partientSearch: { 
    MRN: string; 
    PatientName: string; 
    identificationType: string; 
    identificationNumber: string; 
    MobileNo: string; 
    birthDate: string; 
    offset: number; 
    limit: number; 
  };
  datePreferanceDiaplay:string="";
  isSubmitting: boolean = false;
  primaryIdFilteredList: any;
  defaultIdentification: string='';
  primaryIdCode: any;
  unitName: string;
  orgCode: string;
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  maxIdentificationLength:number=25;
  minIdentificationLength:number=0;

  constructor(
    public dialogRef: MatDialogRef<DialogAddAppointmentPatient>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAddAppointmentPatient,
    public baseservice: AppBaseService,
    public snackBar: MatSnackBar,
    public loadingBar: LoadingBarService,
    private authService: AuthService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private patientService: PatientService,
    private applicationConfigService: ApplicationConfigService,
    private langService: MultiLanguageService,
    public generalApiServiceapt: GeneralUrlService,
    public masterApiServiceapt: MasterUrlService,
    private appoinmentServiceApt: AppointmentService,
    private reportService: ReportService, 
    private appBaseService: AppBaseService,
    public masterApiService: MasterUrlService,
    private ngxService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.getUnitData();
    this.dilogData = data;

    this.dilogData.daySlot.forEach((element) => {
      if (element.id == data.slotId) {
        this.slectedSlotId.push(element.id);
        element[OPD_CONST.aptref.selected] = true;
      } else {
        var currentTime = new Date().getTime() / 1000;
        if (currentTime < element.startDateTimeEpoch) {
          var minutesToAdd = this.dilogData.blocktime;
          var currentDate = new Date();
          var cuurentTimeappconfig =
            Number(new Date(currentDate.getTime() + minutesToAdd * 60000)) /
            1000;

          if (cuurentTimeappconfig > element.startDateTimeEpoch) {
            element[OPD_CONST.aptref.selected] = false;
            element[OPD_CONST.aptref.past] = false;
            // element[OPD_CONST.aptref.blocked] = true;
          } else {
            element[OPD_CONST.aptref.selected] = false;
            element[OPD_CONST.aptref.past] = false;
            // element[OPD_CONST.aptref.blocked] = false;
          }
        } else {
          element[OPD_CONST.aptref.selected] = false;
          element[OPD_CONST.aptref.past] = true;
        }
        element[OPD_CONST.aptref.blocked] = element.businessStatus === OPD_CONST.aptSlotStatus.HOLD;
        element[OPD_CONST.aptref.booked] = element.businessStatus === OPD_CONST.aptSlotStatus.busy;
        element[OPD_CONST.aptref.available] = element.businessStatus === OPD_CONST.aptSlotStatus.free;
        if(element.tempStatus){
          element[OPD_CONST.aptref.blocked] = element.tempStatus ===OPD_CONST.aptSlotStatus.blocked;
        }
      }
     
    });

    this.selectedSlots = {
      start: this.dilogData.calenderEvent
        ? this.dilogData.calenderEvent.StartTime
        : this.dilogData.selectedSlots.start,
      end: this.dilogData.calenderEvent
        ? this.dilogData.calenderEvent.EndTime
        : this.dilogData.selectedSlots.end,
    };
    if (this.dilogData.isQuickSearch) {
      this.selectedSlots = {
        start: this.dilogData.selectedTime
          ? this.dilogData.selectedTime.start
          : this.dilogData.selectedTime.start,
        end: this.dilogData.selectedTime
          ? this.dilogData.selectedTime.end
          : this.dilogData.selectedTime.end,
      };
      this.slectedSlotId.push(this.dilogData.slotId);
    }
  }
  /**
   *Load metthod of dialog window
   *
   * @memberof DialogAddAppointmentPatient
   */
  ngOnInit() {
    this.getPrimaryIdList();  
     this.appointmentForm = this.formBuilder.group({
      IdNumber: [null, [removeSpaces]],
      IdType: ["", Validators.required],
      Title: ["", Validators.required],
      FullName: [null, [Validators.required]],
      Gender: [""],
      DOB: ["", Validators.required],
      realdob: [true],
      idExpiry: [""],
      Age: [""],
      // Email: [
      //   "",
      //   [
      //     Validators.pattern(
      //       "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"
      //     ),
      //   ],
      Email: [
        "",
        [this.emailOrMaskedValidator()]
      
      ],
      countryCodemobile: ["", [Validators.required]],
      HandPhoneNumber: [null, [Validators.required, removeSpaces]],
      OffciePhoneNumber: [""],
      HomePhoneNumber: [""],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      pincodePrimary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      addressPrimary: [""],
      CompanyType: [""],
      SubSpecility: [""],
      Remarks: [""],
    });
    this.searchList = this.appoinmentServiceApt.appoinmentSearchList(this);
    this.authService.getUnit().then((value: any) => {
      this.unitId = value.unitId;
      this.orgId = value.orgId;
      this.unitCode = value.unitCode;
    });
    this.langService.getCurrentLanguage().then((val) => {
      this.langValue = val;
      if (this.langValue == "en") this.Data = OPD_CONST.specialReqirements;
      else this.Data = OPD_CONST.specialReqirementsMY;
    });
    this.getCountryList();
    this.getspecialReqList();
    this.getHealthPackgeList();
    this.searchOnChanges();
    this.isHsc =
      this.dilogData.appointmentType == OPD_CONST.aptref.apttTypeHscCode
        ? true
        : false;
    if (this.dilogData.reScheduleData) {
      this.autoRescheduleData = this.dilogData.reScheduleData;
      this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
        ? this.setTempPatient(this.autoRescheduleData)
        : this.setSearch(this.autoRescheduleData);
      let patientType =
        this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
          ? OPD_CONST.aptref.new
          : OPD_CONST.appoinmentRef.registred;
      this.patientType = patientType;
      this.patientTypeCat = patientType;
      this.isPatientNew = patientType == OPD_CONST.aptref.new;
       if(this.patientType=="registered"){
          this.appointmentForm.disable();
        }else{
          this.appointmentForm.enable();
        }
    }
    if(this.dilogData.waitingPatient?.id){
      setTimeout(() => {
        this.getWaitingpatient();
      }, 1500);
    }
    this.reasonTypeMaster();
    this.onChanges();
    this.authService.getUserInfo().then((value: any) => {
      if (value.userSpecialRightList && value.userSpecialRightList.length > 0) {
        value.userSpecialRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightOverRighteBlockedSlot)
            this.isOverRightBlockedSlot = true;
        });
      }
    });
  } 
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.getOrgAppConfigList();
    });
  }

    getOrgAppConfigList() {
      let appConfig: any;
       this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
          this.appBaseService
            .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
            .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res) {
            appConfig = res.keys;
            appConfig.forEach((element) => {
             
              if (element.key == MasterKeys.primaryIdentification){
                if (element.valueList?.length > 0 && element.valueList[0]?.code) {
                  let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code)
                  if (!this.primaryValue) {
                    this.primaryValue = value ? value.code : "";
                    this.appointmentForm.controls["IdType"].setValue(this.primaryValue);
                    this.cdr.detectChanges();
                    this.primaryIdentificationOnChange(value, false);
                  }  
              }
            }
          });
          } 
        });
    }   

  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.primaryIdFilteredList = data.filter((i) => i.isPrimaryId);
      });
  }
  
  onChanges() {
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonList = this.reasons.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  /**
   * To initiate quick search
   * @param event
   */
  searchByMRN(event) {
    let result = { MRN: event.target.value };
    this.setSearch(result);
  }
  /**
   *on click checkbox change event
   *
   * @param {*} e
   * @param {*} data
   * @param {*} isReschedue
   * @memberof DialogAddAppointmentPatient
   */
  onCheckboxChange(e: any, data, isReschedue) {
    if (isReschedue) {
      this.checkArray.push(data);
    } else {
      if (e.target.checked) {
        this.checkArray.push(data);
      } else {
        const index: number = this.checkArray.indexOf(data);
        if (index !== -1) {
          this.checkArray.splice(index, 1);
        }
      }
    }
  }
  /**
   *search change event
   *
   * @memberof DialogAddAppointmentPatient
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.appointmentForm.controls["DOB"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
  }
  /**
   *add minutes
   *
   * @param {*} date
   * @param {*} minutes
   * @return {*}
   * @memberof DialogAddAppointmentPatient
   */
  addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  /**
   *select slot event
   *
   * @param {*} slot
   * @memberof DialogAddAppointmentPatient
   */
  slectedSlot(slot) {
    if(this.isOverRightBlockedSlot  && !slot.booked && !slot.past){
      if (slot.selected) {
        slot.selected = false;
      } else {
        this.dilogData.daySlot.forEach((element) => {
          if (element.selected === true) {
            element.selected = false;
          }
        });
        var intialselectedIndex = this.dilogData.daySlot.findIndex(
          (i) => i.selected === true
        );
        var selectedIndex = this.dilogData.daySlot.findIndex(
          (i) => i.id === slot.id
        );

        if (intialselectedIndex <= 0) {
          slot.selected = true;
        }
        if (
          selectedIndex === intialselectedIndex - 1 ||
          selectedIndex === intialselectedIndex + 1
        ) {
          slot.selected = true;
        }
        var prev = this.dilogData.daySlot[selectedIndex - 1].selected;
        var next = this.dilogData.daySlot[selectedIndex + 1].selected;
        if (prev || next) {
          slot.selected = true;
        }
      }
      this.slotSelectedasGroup();
    
    }else{
    if (slot.past) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.slotIsUnavailable"),
        {
          duration: 3000,
        }
      );
    }else if(slot.booked){
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.slotIsAlreadybooked"),
        {
          duration: 3000,
        });
    } else {
      if (slot.blocked) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.slotIsBlocked"),
          {
            duration: 3000,
          }
        );
      } else {
        if (slot.selected) {
          slot.selected = false;
        } else {
          this.dilogData.daySlot.forEach((element) => {
            if (element.selected === true) {
              element.selected = false;
            }
          });
          var intialselectedIndex = this.dilogData.daySlot.findIndex(
            (i) => i.selected === true
          );
          var selectedIndex = this.dilogData.daySlot.findIndex(
            (i) => i.id === slot.id
          );

          if (intialselectedIndex <= 0) {
            slot.selected = true;
          }
          if (
            selectedIndex === intialselectedIndex - 1 ||
            selectedIndex === intialselectedIndex + 1
          ) {
            slot.selected = true;
          }
          var prev = this.dilogData.daySlot[selectedIndex - 1].selected;
          var next = this.dilogData.daySlot[selectedIndex + 1].selected;
          if (prev || next) {
            slot.selected = true;
          }
        }
        this.slotSelectedasGroup();
      }
    }
    }
  }
  /**
   *selected as group
   *
   * @memberof DialogAddAppointmentPatient
   */
  slotSelectedasGroup() {
    this.slectedSlotId = [];
    var slected: any = [];
    this.dilogData.daySlot.forEach((element) => {
      if (element.selected) {
        slected.push(element);
        this.slectedSlotId.push(element.id);
      }
    });

    this.selectedSlots = {
      start: slected[0].start,
      end: slected[slected.length - 1].end,
    };
  }

  /**
   *get data Reason master
   *
   * @memberof DialogAddAppointmentPatient
   */
  reasonTypeMaster() {
      const isReschedule =  this.autoRescheduleData ? this.autoRescheduleData.appointmentType : false
     if (isReschedule==true){
      this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"APRS",true)
        .subscribe((res) => {
          res.forEach((element) => {
            this.reasonList.push(element);
            this.reasons.push(element);
          });
        });
     }
    else {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_REASON_MASTER_QUERY)
        .subscribe((data: any) => {
          this.reasonList = data;
          this.reasons =data;
        })
      );
  }
}
  /**
   *It is the source of country data.
   *
   * @memberof PatientRegistrationComponent
   */
  getCountryList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_COUNTRY,true)
        .subscribe((data: any) => {
          this.countryPrimaryList = data;
        })
    );
  }
  getPrifixList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PREFIX)
        .subscribe((data: any) => {
          this.prefixCodeList = data;
        })
    );
  }

  getspecialReqList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_SPECIALREQLIST,true)
        .subscribe((data: any) => {
          this.specialReqList = data;
        })
    );
  }

  /**
   *get health package
   *
   * @memberof DialogAddAppointmentPatient
   */
  getHealthPackgeList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PACKAGE,true)
        .subscribe((data: any) => {
          this.healthPackageList = data;
        })
    );
  }
  /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
          )
          .subscribe((res) => {
            this.statePrimaryList = res;
            if (this.selectedPatient) {
              const stateres = this.statePrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.stateList[0].code
                        : this.selectedPatient.extendedAddress.state.code
                      : this.selectedPatient.extendedAddress.state.code
                    : "")
              );
              this.stateValue = stateres ? stateres.code : "";
              this.getCityPrimaryList(stateres);
            }
          })
      );
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof PatientRegistrationComponent
   */
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
          )
          .subscribe((res) => {
            this.cityPrimaryList = res;
            if (this.selectedPatient) {
              const cityres = this.cityPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.cityList[0].code
                        : this.selectedPatient.extendedAddress.city.code
                      : this.selectedPatient.extendedAddress.city.code
                    : "")
              );
              this.cityValue = cityres ? cityres.code : "";
              this.getSubDistrictPrimaryList(cityres);
            }
          })
      );
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
          )
          .subscribe((res) => {
            this.subdistPrimaryList = res;

            if (this.selectedPatient) {
              const distres = this.subdistPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.areaList[0].code
                        : this.selectedPatient.extendedAddress.area.code
                      :this.selectedPatient.extendedAddress.area? this.selectedPatient.extendedAddress.area.code:""
                    : "")
              );
              this.districtValue = distres ? distres.code : "";
            }
          })
      );
    }
  }

  /**
   *identifiation change event
   *
   * @param {*} idTypeCode
   * @memberof DialogAddAppointmentPatient
   */
  // primaryIdentificationOnChange(idTypeCode: any) {
  //   if (idTypeCode.code == OPD_CONST.idTypePassportValue)
  //     this.showExpirDatePicker = true;
  //   else this.showExpirDatePicker = false;
  // }
  primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove:boolean) {
    let appointmentForm = this.appointmentForm.controls;
    if(isPrimaryNoRemove){
    appointmentForm["IdNumber"].setValue('');
    }
    if (idTypeCode.value) {
      this.primaryIdCode = this.primaryIdFilteredList.find(
        (s) => s.code == idTypeCode.value
      );
    }else{
        this.primaryIdCode = this.primaryIdFilteredList.find(
          (s) => s.code == idTypeCode.code
        );
      }
    // if (idTypeCode) {
      if (this.primaryIdCode) {
        if (this.primaryIdCode.isMyKad == true) {
          this.primaryIdRegex = "^[0-9 -]+$";
        } else {
          this.primaryIdRegex = this.primaryIdCode.validation
            ? this.primaryIdCode.validation
            : "";
        }
      }
      if (this.primaryIdCode.expiryDuration) {
        appointmentForm["idExpiry"].enable();
      
              const currentDate = new Date().getFullYear();
              const maxExpiryDurationDate = new Date();
              maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);
      
              this.maxExpiry = maxExpiryDurationDate;
            }
            else{
              this.maxExpiry= new Date(this.year + 20, this.month, this.day);
            }
           if (this.primaryIdCode.validation) {
              this.primaryIdRegex = this.primaryIdCode.validation;
              // this.primaryIdRegex = "^[a-zA-Z0-9]{0,9}$";
             const match = this.primaryIdRegex.match(/\{(\d+),(\d+)\}/);
             this.minIdentificationLength = match ? parseInt(match[1], 10) : null;
             this.maxIdentificationLength = match ? parseInt(match[2], 10) : null;
           
             this.appointmentForm.controls["IdNumber"].setValidators([
               Validators.pattern(this.primaryIdRegex)
             ]);
           }else{
            this.maxIdentificationLength=25;
            this.minIdentificationLength=0;
            this.primaryIdRegex=OPD_CONST.primaryIdRegix;
            this.appointmentForm.controls["IdNumber"].setValidators([
              Validators.pattern(this.primaryIdRegex)
            ]);
           }
           this.appointmentForm.controls["IdNumber"].updateValueAndValidity();
      if (!this.selectedPatient) {
        if (this.primaryIdCode.code == OPD_CONST.idTypePassportValue) {
          appointmentForm["idExpiry"].setValue("");
          appointmentForm["idExpiry"].enable();
          this.showExpirDatePicker = true;

          // appointmentForm.issuedCountryPrimary.setValue("");
          // appointmentForm.issuedCountryPrimary.enable();
        } else {
          appointmentForm["idExpiry"].setValue("");
          appointmentForm["idExpiry"].disable();

          // appointmentForm.issuedCountryPrimary.setValue("");
          // appointmentForm.issuedCountryPrimary.disable();
          this.showExpirDatePicker = false;
        }
        this.primaryNumberOnKeyUp(appointmentForm["IdNumber"].value);
      }
    // }
  }
  /**
   *calling method after focus out
   *
   * @param {string} value
   * @memberof DialogAddAppointmentPatient
   */
  idFocusOut(value: string) {
    this.validationOnPrimarynumber(value);
    if (this.patientId) {
      if (this.selectedPatient.id) this.primaryIdentifierListModified = true;
    }

    let primaryIdCode = this.appointmentForm.get("primaryId").value;
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && value.length < 14)
        this.appointmentForm.controls["primaryNumber"].setErrors({
          incorrect: true,
        });
    }
  }
  /**
   *adding validation on primary number
   *
   * @param {string} value
   * @memberof DialogAddAppointmentPatient
   */
  primaryNumberOnKeyUp(value: string) {
    try {
      let primaryIdCode = this.appointmentForm.value.IdType;
      value = value.replace(/\s/g, '');
      this.appointmentForm.controls["IdNumber"].setValue(value);
      if (primaryIdCode) {
        if (primaryIdCode == OPD_CONST.idTypemykadValue) {
        }
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode.code
        );

        if (primaryIdCode) {
          if (primaryIdCode.isMyKad) {
            var r = /(\D+)/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            this.appointmentForm.controls["IdNumber"].setValue(value ? value : "");
            this.primaryIdRegex = "^[0-9 -]+$";
          }
          if (value.length >= 12 && primaryIdCode.isMyKad) {
            // if (
            //   value.length == 14 &&
            //   primaryIdCode == OPD_CONST.appoinmentRef.myKad
            // )
            const array = Array.from(c);
            if (array[0] + array[1] >= "30" && array[0] + array[1] <= "99") {
              const Calculated_year = array[0] + array[1];
              const cal_month = array[2] + array[3];
              const cal_day = array[4] + array[5];

              const yr = +Calculated_year;
              const mn = +cal_month;
              const dat = +cal_day;
              this.appointmentForm.controls["DOB"].setValue(
                new Date(yr, mn - 1, dat)
              );
              this.appointmentForm.controls["realdob"].setValue(true);
            } else if (
              array[0] + array[1] >= "00" &&
              array[0] + array[1] <= "29"
            ) {
              const Calculated_year = "2" + "0" + array[0] + array[1];
              const cal_month = array[2] + array[3];
              const cal_day = array[4] + array[5];

              const yr = +Calculated_year;
              const mn = +cal_month;
              const dat = +cal_day;
              var d = new Date();
              var n = d.getFullYear();
              if (parseInt(Calculated_year) > n) {
                this.snackBar.open(
                  this.langService.get("CommonAppoinment.FutureAgeMessage"),
                  this.langService.get("CommonAppoinment.warning"),
                  {
                    duration: 10000,
                  }
                );
                this.appointmentForm.controls["DOB"].setValue("");
              } else {
                this.appointmentForm.controls["DOB"].setValue(
                  new Date(yr, mn - 1, dat)
                );
              }
            }
          }
        }
      }
    } catch (ex) {}
  }
  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
   validationOnPrimarynumber(value: string) {
    if (this.patientId == "" && value.length > 0) {
      let primaryIdCode = this.appointmentForm.controls["IdType"].value;
      if (primaryIdCode) {
        this.generalApiServiceapt
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode.code + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if(res!=null){
             this.appointmentForm.controls["IdNumber"].setValue("");
            }
           });
      }
    }
  }
  /**
   *
   *
   * @param {*} companyValue
   * @memberof DialogAddAppointmentPatient
   */
  pakageChecked(packageValue) {
    this.checkedPackageList = [];
    for (let i = 0; i < this.healthPackageList.length; i++) {
      if (packageValue.indexOf(this.healthPackageList[i]) != -1)
        this.checkedPackageList.push(this.healthPackageList[i]);
    }
  }
  /**
   *binding gender value
   *
   * @param {*} prefixvalue
   * @memberof DialogAddAppointmentPatient
   */
  // getGender(prefixvalue) {
  //   let formappoinment = this.appointmentForm.controls;
  //   let res =
  //     prefixvalue && prefixvalue.genderMaster
  //       ? prefixvalue.genderMaster.code
  //       : "";
  //   if (res) {
  //     this.genderValue = res;
  //     formappoinment.Gender.disable();
  //   } else {
  //     this.genderValue = "";
  //     formappoinment.Gender.enable();
  //   }
  // }

  getGender(prefixvalue) {
    let formRegistration = this.appointmentForm.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["gender"].disable();
    } else {
      this.genderValue = this.defaultGender ? this.defaultGender :this.genderValue ;
      formRegistration["gender"].enable();
    }
  }
  /**
   *calculate DOB method
   *
   * @param {string} age
   * @param {string} month
   * @memberof DialogAddAppointmentPatient
   */
  // calculateDob(age: string, month: string) {
  //   let agecalc;
  //   let monthcalc;

  //   if (age != "0") {
  //     agecalc = age.split("Y", 1);
  //   } else {
  //     agecalc = 0;
  //   }
  //   if (month != "0") {
  //     monthcalc = month.split("M", 1);
  //   } else {
  //     monthcalc = 0;
  //   }
  //   var todayDate = new Date();
  //   var ageyear = todayDate.getFullYear() - Number(agecalc);
  //   var agemonth = todayDate.getMonth() - Number(monthcalc);
  //   var ageday = todayDate.getDate() - 0;
  //   this.appointmentForm.controls.DOB.setValue(
  //     new Date(ageyear, agemonth, ageday)
  //   );
  // }
  calculateDob(age: string, month: string) {
    let formAppointment = this.appointmentForm.controls;

    let agecalc;
    let monthcalc;

    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
    var todayDate = new Date();
    var ageyear = todayDate.getFullYear() - Number(agecalc);
    var agemonth = todayDate.getMonth() - Number(monthcalc);
    var ageday = todayDate.getDate() - 0;
    this.appointmentForm.controls["DOB"].setValue(
      new Date(ageyear, agemonth, ageday)
    );
    formAppointment["DOB"].setValue(new Date(ageyear, agemonth, ageday));

  }
  /**
   *clear form
   *
   * @memberof DialogAddAppointmentPatient
   */
  clearForm() {
    this.imageUser = null;
    this.appointmentForm.reset();
    this.patientInfoDisplay = null;
    this.resultFound = false;
    this.patientData=false;
  }
  /**
   *On save click calling method
   *
   * @param {*} form
   * @return {*}
   * @memberof DialogAddAppointmentPatient
   */
   onSubmit(form) {
    if(this.dilogData.waitingPatient){
      this.ngxService.start();

      let Payload={
        id:this.dilogData.waitingPatient.id,
        startTimeEpoch: new Date(this.selectedSlots.start).getTime() / 1000,
        endTimeEpoch: new Date(this.selectedSlots.end).getTime() / 1000,
        slots: this.slectedSlotId
    }
    this.generalApiServiceapt
    .patchTypeApi(
      OPD_API_URL.OPD_SERVICE,
      OPD_API_URL.CONFIRM_WAITING_PATIENT,
      Payload
    )
    .subscribe((response: any) => {
      this.ngxService.stop();
      if(response){
        this.snackBar.open("Patient Confirm Successfully","Success",{duration:2000});
        this.dialogRef.close();
      
        this.appointmentForm.reset();
        this.reason = "";
        if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
          localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
      }
    })
    }else{
    for (var i in this.appointmentForm.controls) {
      this.appointmentForm.controls[i].markAsTouched();
    }
    if (this.appointmentForm.valid || this.appointmentForm.disabled) {
      const isReschedule =  this.autoRescheduleData ? this.autoRescheduleData.appointmentType : false
     if (isReschedule==true){
      if(!this.reason){
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.selectreason"),
        {
          duration: 3000,
        }
      );
      return;
      }
     }
      if (this.isHsc && this.checkedPackageList.length == 0) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.pleaseEnterallmandatory"),
          {
            duration: 3000,
          }
        );
        return;
      } else {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "20pc",
          data: { displayText: "doyouwanttoproceed" },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result.confirm == "yes") {
              this.saveAppointment(form);
            }
          })
        );
      }
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.pleaseEnterallmandatory"),
        {
          duration: 3000,
        }
      );
      return;
    }
  }
  }
  
  /**
   *save appointment method
   *
   * @param {*} form
   * @memberof DialogAddAppointmentPatient
   */
  saveAppointment(form) {
let specialList=[];
   if(this.checkArray.length>0)
  {
   this.checkArray.forEach(element => {
    let listItem = {
      system: "EN",
      code: element.code,
      display: element.desc
  }
     specialList.push(listItem)
   });
   }
    this.saveAction = true;
    var patCat: any = {};
    var patient: any = {};
    if (this.patientTypeCat == OPD_CONST.aptpatientType.desc) {
      patCat = {
        code: OPD_CONST.aptpatientType.code,
        display: OPD_CONST.aptpatientType.desc,
        system: OPD_CONST.aptpatientType.system,
      };
      patient = {
        code: this.selectedPatient.mrn,
        display: this.selectedPatient.id,
        system: OPD_CONST.appoinmentRef.extendedPatient,
      };
    } else {
      patCat = {
        code: OPD_CONST.aptpatientTypeTemp.code,
        display: OPD_CONST.aptpatientTypeTemp.desc,
        system: OPD_CONST.aptpatientTypeTemp.system,
      };
      patient = {
        code: "",
        display: "",
        system: "",
      };
    }
    var obj = {
      code: "",
      display: "",
      system: "",
    };
    let aptTypeValue = this.dilogData.appointmentTypeList.find(
      (s) => s.code == this.dilogData.appointmentType
    );
    let conTypeValue = this.dilogData.consultationtypeList.find(
      (s) => s.code == this.dilogData.consultationtype
    );
    let deptValue = this.dilogData.departmentList.find(
      (s) => s.code == this.dilogData.department
    );
    let reasonValue = this.reasonList.find((s) => s.code == this.reason);
    var serviceCategory = {
      code: aptTypeValue.code,
      display: aptTypeValue.desc,
      system: OPD_CONST.aptpatientType.system,
    };
    var reason = {
      code: reasonValue ? reasonValue.code : "",
      display: reasonValue ? reasonValue.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    var consultationType = {
      code: conTypeValue ? conTypeValue.code : "",
      display: conTypeValue ? conTypeValue.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let service = this.getObjByCode(
      this.dilogData.appointmentTypeList,
      this.dilogData.appointmentType
    );
    let entitydesc = this.getObjByCode(
      this.dilogData.doctorList,
      this.dilogData.doctor.code
    );
    let countryCode = {
      code: form.controls.countryCodemobile.value
        ? form.controls.countryCodemobile.value.code
        : "",
      display: form.controls.countryCodemobile.value
        ? form.controls.countryCodemobile.value.desc
        : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let packageList = [];
    if (this.checkedPackageList.length > 0) {
      this.checkedPackageList.forEach((element) => {
        let res = this.langService.createObjectList(element);
        packageList.push(res[0], res[1]);
      });
    }

    let payload = {
      idTypeList: this.langService.createObjectList(form.controls.IdType.value),
      idNumber: form.value.IdNumber,
      idExpiry: form.value.idExpiry ? form.value.idExpiry.$d : "",
      titleList: this.langService.createObjectList(form.controls.Title.value),
      patientName: form.value.FullName,
      photo: {
        contentType: "image/jpeg",
        url:  this.imageUser,
      },
      genderList: this.langService.createObjectList(form.controls.Gender.value),
      caseTypeList: null,
      dob: form.value.DOB,
      email: form.value.Email,
      countryCode: countryCode,
      mobileNo: form.value.HandPhoneNumber,
      officeNo: form.value.OffciePhoneNumber,
      homeNo: form.value.HomePhoneNumber,
      patientType: patCat,
      patient: patient,
      referalEntity: null,
      companyList: null,
      subSpecialityList: null,
      remarks: form.value.Remarks ? form.value.Remarks : null,
      specialityList: this.langService.createObjectList(deptValue),
      doctorList: this.langService.createObjectList(entitydesc),
      startTimeEpoch: new Date(this.selectedSlots.start).getTime() / 1000,
      endtimeEpoch: new Date(this.selectedSlots.end).getTime() / 1000,
      serviceList: this.langService.createObjectList(service),
      serviceCategory: serviceCategory,
      slots: this.slectedSlotId,
      appointmentType: serviceCategory,
      consultationType: consultationType,
      isReal: form.value.realdob,
      extendedAddress: {
        countryList: this.langService.createObjectList(
          form.controls.countryPrimary.value
        ),
        cityList: this.langService.createObjectList(
          form.controls.cityPrimary.value
        ),
        stateList: this.langService.createObjectList(
          form.controls.statePrimary.value
        ),
        areaList: this.langService.createObjectList(
          form.controls.subDistrictPrimary.value
        ),
        postCode: form.value.pincodePrimary ? form.value.pincodePrimary : null,
        addressLine: form.value.addressPrimary
          ? form.value.addressPrimary
          : null,
      },
      specialRequirements: this.checkArray.length>0?specialList:[],
      trn: this.dilogData.reScheduleData
        ? this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
          ? this.dilogData.reScheduleData.MRN
          : ""
        : "",
      existingAppointmentId: this.dilogData.reScheduleData
        ? this.dilogData.reScheduleData.id
        : "",
      rescheduleRemarks: this.dilogData.reScheduleData ? this.reschRemarks : "",
      reason: reason ? reason : obj,
      packageList: packageList,
    };
    this.generalApiServiceapt
      .postTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_APPOINTMENT_SAVE,
        payload
      )
      .subscribe((response: any) => {
        this.saveAction = false;
    
      let isReschedue=this.dilogData.reScheduleData?this.dilogData.reScheduleData.isReschedule:false;
        let message=isReschedue?   this.langService.get("CommonAppoinment.successfullyrescheduled"):this.langService.get("CommonAppoinment.successfullycreated")
        this.snackBar.open(
          this.langService.get("CommonAppoinment.success"),

          this.langService.get(
            message
          ),
          {
            duration: 5000,
          }
        );
        this.dialogRef.close();
        let reqPayload = {
          transactionId: response.appointment ? response.appointment.id : "",
          type: OPD_REPORT_TYPE.pdf,
          reportName: OPD_REPORT_NAME.appointment_Slip,
          isReports: false,
        };
        localStorage.setItem(
          OPD_CONST.reportPayload,
          JSON.stringify(reqPayload)
        );
        window.open(opdNavigation.REPORT_NAVIGATE);
        this.appointmentForm.reset();
        this.reason = "";
        if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
          localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
      });
  }
  
  /**
   *getobj method
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof DialogAddAppointmentPatient
   */
  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }
  /**
   *selectd image
   *
   * @memberof DialogAddAppointmentPatient
   */
  selectFile() {
    document.getElementById(OPD_CONST.appoinmentRef.fileAttachment).click();
  }

  /**
   *select handle file
   *
   * @param {*} evt
   * @memberof DialogAddAppointmentPatient
   */
  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }
  /**
   *load event for image
   *
   * @param {*} readerEvt
   * @memberof DialogAddAppointmentPatient
   */
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.imageUser = OPD_CONST.appoinmentRef.imageData + this.base64textString;
  }

  /**
   *Destroy method
   *
   * @memberof DialogAddAppointmentPatient
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum / 1000;
  }
  /**
   *selection change value
   *
   * @param {*} name
   * @param {*} value
   * @memberof DialogAddAppointmentPatient
   */
  selectOnChange(name, value) {
    this.dropdownValues[name] = value.id;
  }
  /**
   *Select on click
   *
   * @param {*} control
   * @param {*} parent
   * @param {*} child
   * @memberof DialogAddAppointmentPatient
   */
  selectOnClick(control, parent, child) {
    let _this = this;
    try {
      let value = "";
      let hasParam = false;
      if (
        control.url &&
        control.url.includes("{") &&
        control.url.includes("{") &&
        !control.url.includes("{UnitMaster}")
      ) {
        let param = control.url.substring(
          control.url.lastIndexOf("{") + 1,
          control.url.lastIndexOf("}")
        );
        if (this.dropdownValues[param]) {
          control.url = control.url.replace(
            /\{.*?\}/,
            "'" + this.dropdownValues[param].trim() + "'"
          );
        } else {
          control.url = control.url.replace(/\{.*?\}/, "''");
        }
        hasParam = true;
      }
      if (
        !this.searchList[parent].controls[child].options ||
        this.searchList[parent].controls[child].options.length == 0 ||
        hasParam
      ) {
        this.baseservice.setResourceURL("/");
        this.subscriptionList.add(
          this.baseservice.getResource(control.url).subscribe((res) => {
            this.searchList[parent].controls[child].options = res;
            setTimeout(() => {
              document.getElementById(control.name).click();
            }, 500);
          })
        );
      }
    } catch (ex) {}
  }
  /**
   *Clear Search
   *
   * @memberof DialogAddAppointmentPatient
   */
  clearSearch() {
    this.searchList.forEach((search) => {
      search.controls.forEach((control) => {
        this[control.name] = "";
        control.searchValue = "";
        control.options=control.masterList;
      });
    });
  }

    dropdownOnSearch(control: SearchControl, event) {
      if (!control.masterList || control.masterList.length == 0)
        control.masterList = control.options;
      control.searchValue = event.srcElement.value;
      if (control.masterList.length > 0) {
        control.options = control.masterList.filter((i) =>
          i.desc.toString().toLowerCase().includes(control.searchValue.toLowerCase())
        );
      }
    }
  /**
   *set Search existing Patient data
   *
   * @param {*} data
   * @memberof DialogAddAppointmentPatient
   */
  setSearch(data) {

    let keysArray = Object.keys(data);
    let hasValue = false;
    
    for (let i = 0; i < keysArray.length; i++) {
      let value = data[keysArray[i]];
      if (  value !== "" && value !== null && value !== undefined 
      ) {
        hasValue = true;
        break; 
      }
    }
    
    if (hasValue) {
      const birthDate = data.dob
      ?  moment(data.dob, "DD/MM/YYYY hh:mm:ss aa").format("YYYY-MM-DD")
      : "";
      this.partientSearch = {
        MRN: data.MRN ? data.MRN : "",
      PatientName: data.PatientName ? data.PatientName : "",
      identificationType: data.identificationType
        ? data.identificationType
        : "",
      identificationNumber: data.identificationNumber
        ? data.identificationNumber
        : "",
      MobileNo: data.MobileNo ? data.MobileNo : "",
      birthDate: birthDate,
      offset: this.offset,
      limit: this.limit,
    };
    this.clearSearch();
    var payload = this.appoinmentServiceApt.getSearchPatient(this.partientSearch);
    this.subscriptionList.add(
      this.generalApiServiceapt
        .getTypeApi(OPD_API_URL.OPD_SERVICE, payload)
        .subscribe((res) => {
          this.patientList = res;
          this.patientData = true;
          this.recordsLength = res.length;
          this.resultFound = true;
          this.displayedColumns = OPD_CONST.displaypatientList;
          const existingData = this.dataSource?.data || [];
          const updatedData = [...res];
          this.dataSource = new MatTableDataSource<any>(updatedData);
          this.loadingData = false;
          if (this.dilogData.reScheduleData)
            this.radioClicked1(this.patientList[0]);
        })
    );
    } else {
       this.snackBar.open(
        this.langService.get("CommonAppoinment.onesearchparameter"),
        this.langService.get("CommonAppoinment.warning"),
         {
        duration: 3000,
      });
    }
  }
  /**
   *set temp patient data
   *
   * @param {*} data
   * @memberof DialogAddAppointmentPatient
   */
  setTempPatient(data) {
    var partientSearch = {
      mrn: data.MRN ? data.MRN : "",
    };
    this.clearSearch();
    this.baseservice.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.baseservice
        .getResource(OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + partientSearch.mrn)
        .subscribe((res) => {
          this.recordsLength = res.length;
          this.resultFound = true;
          this.displayedColumns = OPD_CONST.displaypatientList;
          this.dataSource = new MatTableDataSource<any>(res);
          if (this.dilogData.reScheduleData) this.resultFound = false;
          this.selectedPatient = res;
          (this.genderValue = res.genderList ? res.genderList[0].code : ""),
            (this.primaryValue = res.primaryIdentificationType
              ? res.primaryIdentificationType[0].code
              : ""),
            (this.prefixValue = res.prefixList ? res.prefixList[0].code : ""),
            (this.mobileCodeValue = res.countryCode
              ? res.countryCode.code
              : ""),
            (this.countryValue = res
              ? res.extendedAddress
                ? res.extendedAddress.countryList
                  ? res.extendedAddress.countryList[0].code
                  : null
                : null
              : null);
          let remarks = this.dilogData.reScheduleData
            ? this.dilogData.reScheduleData.remarks
            : "";
          this.appointmentForm.patchValue({
             IdType: res.primaryIdentificationType
               ? res.primaryIdentificationType[0].code
               : "",             
            IdNumber: res.idNumber ? res.idNumber : "",
            FullName: res.patientName,
            Email: res.email ? res.email : "",
            HandPhoneNumber: res.mobileNo ? res.mobileNo : "",
            OffciePhoneNumber: res.officeNo ? res.officeNo : "",
            HomePhoneNumber: res.homeNo ? res.homeNo : "",
            DOB: res.dob ? new Date(res.dob) : "",
            idExpiry: res.idExpiry ? new Date(res.idExpiry) : "",
            Remarks: remarks,
            addressPrimary: res.extendedAddress
              ? res.extendedAddress.addressLine
              : "",
            pincodePrimary: res.extendedAddress
              ? res.extendedAddress.postCode
              : "",
          });
          this.getStatePrimaryList(
            res.extendedAddress && res.extendedAddress.countryList
              ? res.extendedAddress.countryList[0].code
              : "",
            true
          );
        })
    );
  }
  /**
   *mobile format
   *
   * @memberof DialogAddAppointmentPatient
   */
  mobileNumberFormat() {
    let trimmedNumber = this.mobile.replace(/-/g, "");
    let A = trimmedNumber.substr(0, 3);
    let B = trimmedNumber.substr(3, 11);
    let str1 = trimmedNumber.length >= 4 ? "-" + B : B;
    this.mobile = A + str1;
  }
  /**
   *days in month
   *
   * @param {*} date2_UTC
   * @return {*}
   * @memberof DialogAddAppointmentPatient
   */
  DaysInMonth(date2_UTC) {
    var monthStart: any = new Date(
      date2_UTC.getFullYear(),
      date2_UTC.getMonth(),
      1
    );
    var monthEnd: any = new Date(
      date2_UTC.getFullYear(),
      date2_UTC.getMonth() + 1,
      1
    );
    var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
    return monthLength;
  }
  /**
   *load slots
   *
   * @memberof DialogAddAppointmentPatient
   */
  loadSlots() {
    const len = this.timeSlotsArray.length;
    for (let i = 0; i < len; i++) {
      const obj = {
        start: "",
        end: "",
        startValue: "",
        endValue: "",
        status: "",
        slotId: "",
      };
      if (
        this.timeSlotsArray[i + 1] &&
        this.timeSlotsArray[i].end == this.timeSlotsArray[i + 1].start
      ) {
        obj.status = this.timeSlotsArray[i].status;
        obj.start = this.timeSlotsArray[i].start;
        obj.end = this.timeSlotsArray[i].end;
        obj.startValue = this.timeSlotsArray[i].startDateTimeEpoch;
        obj.endValue = this.timeSlotsArray[i].endDateTimeEpoch;
        obj.slotId = this.timeSlotsArray[i].id;
      } else {
        if (i + 1 == len) {
          obj.status = this.timeSlotsArray[i].status;
          obj.start = this.timeSlotsArray[i].start;
          obj.end = this.timeSlotsArray[i].end;
          obj.startValue = this.timeSlotsArray[i].startDateTimeEpoch;
          obj.endValue = this.timeSlotsArray[i].endDateTimeEpoch;
          obj.slotId = this.timeSlotsArray[i].id;
        } else {
          if (this.breakTimes.start != undefined) {
            obj.status = "break";

            obj.start = this.breakTimes.start;
            obj.end = this.breakTimes.end;
            obj.startValue = this.breakTimes.start;
            obj.endValue = this.breakTimes.end;
            obj.slotId = "";
          }
        }
      }
      this.timeSlotList.push(obj);
    }
  }
  /**
   *radio clicked
   *
   * @param {*} i
   * @memberof DialogAddAppointmentPatient
   */
  radioClicked1(i) {
    if(i.isBlocked==false) {
      this.patientData=false;
      this.isVip=i.vip;
      this.isNoteVisible = i.patientNotes ? i.patientNotes.note :"";
    this.isDisabled = true;
    this.resultFound = false;
    this.selectedPatient = i;
    (this.genderValue = i.gender ? i.gender.code : ""),
      (this.primaryValue = i.primaryIdentifier ? i.primaryIdentifier.code : ""),
      (this.prefixValue = i.title ? i.title.code : ""),
      (this.mobileCodeValue = i.mobileNumber ? i.mobileNumber.countryCode : i.countryCode?i.countryCode:"");
    this.countryValue = i
      ? i.extendedAddress
        ? i.extendedAddress.country.code
        : null
      : null;
    let remarks = this.dilogData.reScheduleData
      ? this.dilogData.reScheduleData.remarks
      : this.dilogData?.waitingPatient?this.dilogData.waitingPatient.remarks:"";
      this.defaultGender = i.gender ? i.gender.code : ""
      if (i.title) {
        const prefix = this.prefixCodeList.find(item => item.code === i.title.code);
        if (prefix) {
          this.getGender(prefix);
        }
      }
      let mrn=i.mrn?i.mrn:i.identifier[0].value
      let name = Array.isArray(i.name) && i.name.length > 0 ? i.name[0].text || i.name[0] : i.name;
    let gender = i.gender.code.toUpperCase();
    this.appointmentForm.patchValue({
      IdNumber: i.primaryIdentifier ? i.primaryIdentifier.value : "",
      FullName: name,
      Email: i.telecom ? i.telecom[0].value : "",
      HandPhoneNumber: i.mobileNumber ? i.mobileNumber.mobileNumber :  i.telecom ? i.telecom[1].value:"",
      OffciePhoneNumber: i.telecom ? i.telecom[2].value : "",
      HomePhoneNumber: i.telecom ? i.telecom[3].value : "",
      DOB: new Date(i.birthDate),
      IdType:  i.primaryIdentifier ? i.primaryIdentifier.code : "",
      idExpiry: i.primaryIdentifier
        ? i.primaryIdentifier.period
          ? new Date(i.primaryIdentifier.period.end)
          : ""
        : "",
      Remarks: remarks,
      addressPrimary: i.extendedAddress ? i.extendedAddress.addressLine : "",
      pincodePrimary: i.extendedAddress ? i.extendedAddress.postCode : "",
    });
    this.getStatePrimaryList(
      i.extendedAddress && i.extendedAddress.country
        ? i.extendedAddress.country.code
        : "",
      true
    );
    var dobFormatted = "";
    var patientAge = "";
    if (i.birthDate) {
      dobFormatted = this.datepipe.transform(i.birthDate, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      mrn +
      " / " +
      name +
      " / " +
      (gender ? gender : "UNKNOWN") +
      " / " +
      (i.birthDate ? dobFormatted : " ") +
      " (" +
      (this.patientAge ? this.patientAge.years : "") +
      ")";
    Image: i.photo ? i.photo[0].url : "";
  }else{
    this.snackBar.open(
      this.langService.get("CommonAppoinment.alreadyBlocked"),
      this.langService.get("CommonAppoinment.warning"),
      {
      duration: 3000,
    });
  }
  }
  /**
   *set mobiel format values
   *
   * @param {string} value
   * @param {string} name
   * @memberof DialogAddAppointmentPatient
   */
  mobileFormat(value: string, name: string) {
    var r = /(\D+)/g,
      npa = "",
      last4 = "";
    value = value.replace(r, "");
    npa = value.substr(0, 3);
    last4 = value.substr(3, 10);
    value = npa + "-" + last4;
    if (value.replace("-", "").trim() == "") value = "";
    if (name == OPD_CONST.aptref.mobile) {
      this.appointmentForm.controls["HandPhoneNumber"].setValue(value);
    } else if (name == OPD_CONST.aptref.home) {
      this.appointmentForm.controls["HomePhoneNumber"].setValue(value);
    } else if (name == OPD_CONST.aptref.work) {
      this.appointmentForm.controls["OffciePhoneNumber"].setValue(value);
    }
  }
  /**
   *patient type change on event
   *
   * @param {*} $event
   * @memberof DialogAddAppointmentPatient
   */
  public patientTypeChange($event) {
    this.appointmentForm.reset();
    this.patientTypeCat = $event.value;
    this.patientType = $event.value;
    this.isPatientNew = $event.value == "new";
    this.disableForm = this.isPatientNew;
    if(this.patientType=="registered"){
        this.appointmentForm.disable();
    }else{
        this.appointmentForm.enable();
    }
  }
  /**
   *clsose mehthod
   *
   * @memberof DialogAddAppointmentPatient
   */
  closeModal() {
    this.dialogRef.close();
  }

  /**
   * On patient select
   * @param patient patient DTO
   *
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient: PatientDTOObject) {
    this.patient = patient;
    this.patientId = patient.id;
    this.mrn = patient.mrn;
    var dobFormatted = "";
    var patientAge = "";
    if (patient.birthDate) {
      dobFormatted = this.datepipe.transform(patient.birthDate, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      patient.fullName +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.birthDate ? dobFormatted + " " + patientAge : "");
    this.patientImage = patient.photo ? patient.photo.url : "";

    this.radioClicked1(this.data);
  }
  setPatternToMobileNumber(event){
    if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.appointmentForm.controls["HomePhoneNumber"].setValidators([
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      } 
    } else {
      this.appointmentForm.controls["HomePhoneNumber"].markAsTouched();
    }
    this.appointmentForm.controls["HomePhoneNumber"].updateValueAndValidity();
  }
  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight; // viewport
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    const buffer = 500;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit && !this.loadingData) {
      this.loadingData = true; 
      this.offset += 1;
      this.setSearch(this.partientSearch);
    }
  }
  getWaitingpatient(){
    const form = this.appointmentForm.controls;
    const patientData = this.dilogData.waitingPatient?.patient || this.dilogData.waitingPatient?.temporaryPatient || null;

    if(this.dilogData.waitingPatient.specificDateList){
      this.datePreferanceDiaplay = this.convertTimestampsToDates(this.dilogData.waitingPatient.specificDateList);
    }
    if(this.dilogData.waitingPatient.expectedEndDateTime && this.dilogData.waitingPatient.expectedStartDateTime){
      this.datePreferanceDiaplay =`${this.datepipe.transform(new Date(this.dilogData.waitingPatient.expectedStartDateTime  * 1000), 'dd/MM/yyyy') } To
      ${this.datepipe.transform(new Date(this.dilogData.waitingPatient.expectedEndDateTime  * 1000), 'dd/MM/yyyy') }`
    }
     
  this.selectedPatient = patientData;
    if (this.dilogData.waitingPatient?.patientType?.code === 'TEMP') {
      const primaryIdType = patientData.primaryIdentificationType?.[0];
      this.primaryValue = primaryIdType?.code || "";
      this.primaryIdentificationOnChange(primaryIdType,false);
      
      this.prefixValue = patientData.title?.code || '';
      this.genderValue = patientData.gender?.code || '';
      this.mobileCodeValue = patientData.countryCode?.code || '';
      
      const country = patientData.extendedAddress?.country;
      this.countryValue = country?.code || '';
      if (country?.code) {
        this.getStatePrimaryList(country.code, true);
      }
      
      this.stateValue = patientData.extendedAddress?.state?.code || '';
      
      form["IdNumber"].patchValue(patientData.idNumber || "");
      form["FullName"].patchValue(patientData.patientName || "");
      form["Email"].patchValue(patientData.email || "");
      form["HandPhoneNumber"].patchValue(patientData.mobileNumber || "");
      form["OffciePhoneNumber"].patchValue(patientData.officeNo || "");
      form["HomePhoneNumber"].patchValue(patientData.homeNo || "");
      form["DOB"].patchValue(patientData.birthDate ? new Date(patientData.birthDate) : null);
      form["idExpiry"].patchValue(patientData.idExpiry ? new Date(patientData.idExpiry) : null);
      form["Remarks"].patchValue(this.dilogData.waitingPatient?.remarks || "");
      form["addressPrimary"].patchValue(patientData.extendedAddress?.addressLine || "");
      form["pincodePrimary"].patchValue(patientData.extendedAddress?.postCode || "");
      form["realdob"].patchValue(this.dilogData.waitingPatient?.isReal || false);
    }else{
      this.patientType="registered";
      this.radioClicked1(this.selectedPatient);
    }
    this.appointmentForm.disable();
  }
  convertTimestampsToDates(timestamps: number[]): string {
    return timestamps
      .map(timestamp => this.datepipe.transform(new Date(timestamp * 1000), 'dd/MM/yyyy'))
      .join(', ');
  }
  emailOrMaskedValidator(): ValidatorFn {
    const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const maskedPattern = /^[a-zA-Z]\*+[a-zA-Z]$/;
  
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null;
  
      const isEmail = emailPattern.test(value);
      const isMasked = maskedPattern.test(value);
  
      return isEmail || isMasked ? null : { invalidEmailOrMask: true };
    };
  }
}

